/**
 * My API
 *
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/* tslint:disable:no-unused-variable member-ordering */

import { Inject, Injectable, Optional } from '@angular/core';
import { HttpClient, HttpResponse, HttpEvent } from '@angular/common/http';
import { Observable } from 'rxjs';

import { AcknowledgeManyReassignmentsPartner } from '@coin/shared/core/util-models-v2';
import { AssignmentRecordPartner } from '@coin/shared/core/util-models-v2';
import { CalculateManyProrations } from '@coin/shared/core/util-models-v2';
import { CreateComment } from '@coin/shared/core/util-models-v2';
import { CreateManualReassignment } from '@coin/shared/core/util-models-v2';
import { EmployeesEmployeeSnapshot } from '@coin/shared/core/util-models-v2';
import { IncentiveComment } from '@coin/shared/core/util-models-v2';
import { IncentiveEmployeesEmployee } from '@coin/shared/core/util-models-v2';
import { IncentivePartnerDashboardValues } from '@coin/shared/core/util-models-v2';
import { IncentiveRecordPartner } from '@coin/shared/core/util-models-v2';
import { PageOfAssignmentRecordPartner } from '@coin/shared/core/util-models-v2';
import { PageOfIncentiveComment } from '@coin/shared/core/util-models-v2';
import { PageOfIncentiveEmployeesEmployee } from '@coin/shared/core/util-models-v2';
import { PageOfMonitoringRecord } from '@coin/shared/core/util-models-v2';
import { PageOfPlan } from '@coin/shared/core/util-models-v2';
import { PageOfReassignment } from '@coin/shared/core/util-models-v2';
import { PageOfSeason } from '@coin/shared/core/util-models-v2';
import { PageOfString } from '@coin/shared/core/util-models-v2';
import { Reassignment } from '@coin/shared/core/util-models-v2';
import { RecordBatchPartnerResponse } from '@coin/shared/core/util-models-v2';
import { SeasonModel } from '@coin/shared/core/util-models-v2';
import { TransactionStatusOfExportStatusMetadata } from '@coin/shared/core/util-models-v2';
import { TransactionStatusOfIncentiveProrationCalculationMetadata } from '@coin/shared/core/util-models-v2';
import { TransactionStatusOfReassignmentsBatchMetadata } from '@coin/shared/core/util-models-v2';
import { UpdateEmployeeSnapshotPartner } from '@coin/shared/core/util-models-v2';
import { UpdateManyRecordStatesPartner } from '@coin/shared/core/util-models-v2';
import { UpdateReassignment } from '@coin/shared/core/util-models-v2';
import { UpdateRecordIndividualMultiplierValuePartner } from '@coin/shared/core/util-models-v2';
import { UpdateRecordPartner } from '@coin/shared/core/util-models-v2';

// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS } from '../variables';
import { Configuration } from '../configuration';
import { BaseService, RequestArgs, RequestOptions } from '../api.base.service';

export interface CreateCommentRecordsParams {
  recordId: string;
  seasonId: string;
  createComment?: CreateComment;
}

export interface DeleteCommentRecordsParams {
  commentId: string;
  seasonId: string;
  recordId: string;
}

export interface ExportMonitoringParams {
  seasonId: string;
  id?: Array<string>;
  gid?: Array<string>;
  firstName?: Array<string>;
  lastName?: Array<string>;
  country?: Array<string>;
  are?: Array<string>;
  orgCode?: Array<string>;
  planName?: Array<string>;
  state?: Array<'Active' | 'Draft' | 'Outdated' | 'Irrelevant'>;
  startDate?: string;
  endDate?: string;
  payoutDate?: string;
  assignmentManager?: string;
  assignmentId?: string;
  letterType?:
    | 'Other'
    | 'AdherenceLetter'
    | 'TargetAgreementForm'
    | 'TargetAchievementForm'
    | 'MeritAllocation'
    | 'SpecialRecognitionLetter'
    | 'RestructuringCalculation'
    | 'RestructuringLetter';
  processStates?: Array<
    | 'None'
    | 'Open'
    | 'TafCreated'
    | 'TafPublished'
    | 'ReadyForCalculation'
    | 'Calculated'
    | 'Frozen'
    | 'AchievementLetterCreated'
    | 'AchievementLetterPublished'
  >;
  recordCommunicationStates?: Array<
    | 'None'
    | 'Created'
    | 'InManagerReview'
    | 'InEmployeeReview'
    | 'Published'
    | 'ManagerRejected'
    | 'EmployeeRejected'
    | 'NoLetterRequired'
  >;
  workflow?: Array<
    | 'EmployeeConfirmation'
    | 'EmployeeSignature'
    | 'ManagerConfirmationEmployeeConfirmation'
    | 'ManagerConfirmationEmployeeSignature'
    | 'ManagerSignatureEmployeeConfirmation'
    | 'ManagerSignatureEmployeeSignature'
    | 'ManagerConfirmationEmployeeNoActionNeeded'
    | 'NoActionNeeded'
    | 'AllocationByInCompanyManagerInvisibleForLineManager'
    | 'AllocationByInCompanyManagerVisibleForLineManager'
    | 'AllocationByLineManagerApprovalByInCompanyManager'
    | 'AllocationByLineManagerVisibleForInCompanyManager'
    | 'BusinessPartnerConfirmationManagerConfirmationEmployeeConfirmation'
    | 'BusinessPartnerConfirmationManagerConfirmationEmployeeSignature'
    | 'BusinessPartnerConfirmationManagerSignatureEmployeeConfirmation'
    | 'BusinessPartnerConfirmationManagerSignatureEmployeeSignature'
    | 'BusinessPartnerConfirmationManagerConfirmationEmployeeNoActionNeeded'
    | 'BusinessPartnerConfirmationManagerSignatureEmployeeNoActionNeeded'
    | 'BusinessPartnerSignatureManagerConfirmationEmployeeConfirmation'
    | 'BusinessPartnerSignatureManagerConfirmationEmployeeSignature'
    | 'BusinessPartnerSignatureManagerSignatureEmployeeConfirmation'
    | 'BusinessPartnerSignatureManagerSignatureEmployeeSignature'
    | 'BusinessPartnerSignatureManagerConfirmationEmployeeNoActionNeeded'
    | 'BusinessPartnerSignatureManagerSignatureEmployeeNoActionNeeded'
  >;
  template?: Array<string>;
  isDesignReady?: boolean;
  payoutState?: Array<'StandardPayout' | 'FullPayout' | 'DefinedPayoutEndOfFiscalYear' | 'NoPayout' | 'Irrelevant'>;
  managerSetMercerJobCode?: Array<string>;
  editedMercerJobCode?: Array<string>;
  currentMercerJobCode?: Array<string>;
  isMercerJobCodeValid?: boolean;
  isGripCodeValid?: boolean;
  lineManagerName?: string;
  lineManagerGid?: Array<string>;
  seasonId2?: string;
  workflowInstanceState?: Array<
    | 'None'
    | 'InManagerReview'
    | 'ManagerValidated'
    | 'ReviewPeriodClosed'
    | 'Transferred'
    | 'ManagerRejected'
    | 'InAllocation'
    | 'AllocationFinished'
  >;
  multiplier?: number;
  overallTargetAchievement?: number;
  payoutAmount?: number;
  payoutCurrency?: Array<string>;
  ippAchievementValue?: string;
  incentivePaymentType?: string;
  contractStatus?: Array<'Terminated' | 'Dormant' | 'Active' | 'Other'>;
}

export interface ExportReassignmentsParams {
  seasonId: string;
  search?: string;
  targetProperty?:
    | 0
    | 1
    | 2
    | 3
    | 4
    | 5
    | 6
    | 7
    | 8
    | 9
    | 10
    | 11
    | 12
    | 13
    | 14
    | 15
    | 16
    | 17
    | 18
    | 19
    | 20
    | 21
    | 22
    | 23
    | 24
    | 25
    | 26
    | 27;
  id?: string;
  seasonId2?: string;
  gid?: string;
  firstname?: string;
  lastname?: string;
  reason?: Array<string>;
  startDate?: string;
  endDate?: string;
  action?: 'Nothing' | 'AssignNew' | 'TerminateAndReassign' | 'Terminate';
  state?: 'Unknown' | 'Created' | 'Accepted' | 'Rejected' | 'Deactivated';
  areNew?: Array<string>;
  areCurrent?: Array<string>;
  countryNew?: Array<string>;
  countryCurrent?: Array<string>;
  orgCodeNew?: Array<string>;
  orgCodeCurrent?: Array<string>;
  planNameNew?: Array<string>;
  planNameCurrent?: Array<string>;
  targetIncentiveAmountCurrent?: number;
  targetIncentiveAmountNew?: number;
  incentivePaymentTypeCurrent?: Array<string>;
  incentivePaymentTypeNew?: Array<string>;
  orgClusterCurrent?: Array<string>;
  orgClusterNew?: Array<string>;
  managementType?: Array<string>;
  newManagementType?: Array<string>;
}

export interface GetEmployeeByReassignmentIdReassignmentsParams {
  seasonId: string;
  id: string;
}

export interface GetEmployeeForManualReassignmentReassignmentsParams {
  seasonId: string;
  search: string;
  page?: number;
  size?: number;
  orderBy?: 'Asc' | 'Desc';
  property?: string;
}

export interface IncentivePartnerAcceptManyReassignmentAcknowledgementsParams {
  /** Season of reassignment */
  seasonId: string;
  search?: string;
  targetProperty?:
    | 0
    | 1
    | 2
    | 3
    | 4
    | 5
    | 6
    | 7
    | 8
    | 9
    | 10
    | 11
    | 12
    | 13
    | 14
    | 15
    | 16
    | 17
    | 18
    | 19
    | 20
    | 21
    | 22
    | 23
    | 24
    | 25
    | 26
    | 27;
  id?: string;
  seasonId2?: string;
  gid?: string;
  firstname?: string;
  lastname?: string;
  reason?: Array<string>;
  startDate?: string;
  endDate?: string;
  action?: 'Nothing' | 'AssignNew' | 'TerminateAndReassign' | 'Terminate';
  state?: 'Unknown' | 'Created' | 'Accepted' | 'Rejected' | 'Deactivated';
  areNew?: Array<string>;
  areCurrent?: Array<string>;
  countryNew?: Array<string>;
  countryCurrent?: Array<string>;
  orgCodeNew?: Array<string>;
  orgCodeCurrent?: Array<string>;
  planNameNew?: Array<string>;
  planNameCurrent?: Array<string>;
  targetIncentiveAmountCurrent?: number;
  targetIncentiveAmountNew?: number;
  incentivePaymentTypeCurrent?: Array<string>;
  incentivePaymentTypeNew?: Array<string>;
  orgClusterCurrent?: Array<string>;
  orgClusterNew?: Array<string>;
  managementType?: Array<string>;
  newManagementType?: Array<string>;
  acknowledgeManyReassignmentsPartner?: AcknowledgeManyReassignmentsPartner;
}

export interface IncentivePartnerAcceptReassignmentAcknowledgementsParams {
  reassignmentId: string;
  seasonId: string;
}

export interface IncentivePartnerCalculateManyProrationsRecordCalculationsParams {
  seasonId: string;
  id?: Array<string>;
  gid?: Array<string>;
  firstName?: Array<string>;
  lastName?: Array<string>;
  country?: Array<string>;
  are?: Array<string>;
  orgCode?: Array<string>;
  planName?: Array<string>;
  state?: Array<'Active' | 'Draft' | 'Outdated' | 'Irrelevant'>;
  startDate?: string;
  endDate?: string;
  payoutDate?: string;
  assignmentManager?: string;
  assignmentId?: string;
  letterType?:
    | 'Other'
    | 'AdherenceLetter'
    | 'TargetAgreementForm'
    | 'TargetAchievementForm'
    | 'MeritAllocation'
    | 'SpecialRecognitionLetter'
    | 'RestructuringCalculation'
    | 'RestructuringLetter';
  processStates?: Array<
    | 'None'
    | 'Open'
    | 'TafCreated'
    | 'TafPublished'
    | 'ReadyForCalculation'
    | 'Calculated'
    | 'Frozen'
    | 'AchievementLetterCreated'
    | 'AchievementLetterPublished'
  >;
  recordCommunicationStates?: Array<
    | 'None'
    | 'Created'
    | 'InManagerReview'
    | 'InEmployeeReview'
    | 'Published'
    | 'ManagerRejected'
    | 'EmployeeRejected'
    | 'NoLetterRequired'
  >;
  workflow?: Array<
    | 'EmployeeConfirmation'
    | 'EmployeeSignature'
    | 'ManagerConfirmationEmployeeConfirmation'
    | 'ManagerConfirmationEmployeeSignature'
    | 'ManagerSignatureEmployeeConfirmation'
    | 'ManagerSignatureEmployeeSignature'
    | 'ManagerConfirmationEmployeeNoActionNeeded'
    | 'NoActionNeeded'
    | 'AllocationByInCompanyManagerInvisibleForLineManager'
    | 'AllocationByInCompanyManagerVisibleForLineManager'
    | 'AllocationByLineManagerApprovalByInCompanyManager'
    | 'AllocationByLineManagerVisibleForInCompanyManager'
    | 'BusinessPartnerConfirmationManagerConfirmationEmployeeConfirmation'
    | 'BusinessPartnerConfirmationManagerConfirmationEmployeeSignature'
    | 'BusinessPartnerConfirmationManagerSignatureEmployeeConfirmation'
    | 'BusinessPartnerConfirmationManagerSignatureEmployeeSignature'
    | 'BusinessPartnerConfirmationManagerConfirmationEmployeeNoActionNeeded'
    | 'BusinessPartnerConfirmationManagerSignatureEmployeeNoActionNeeded'
    | 'BusinessPartnerSignatureManagerConfirmationEmployeeConfirmation'
    | 'BusinessPartnerSignatureManagerConfirmationEmployeeSignature'
    | 'BusinessPartnerSignatureManagerSignatureEmployeeConfirmation'
    | 'BusinessPartnerSignatureManagerSignatureEmployeeSignature'
    | 'BusinessPartnerSignatureManagerConfirmationEmployeeNoActionNeeded'
    | 'BusinessPartnerSignatureManagerSignatureEmployeeNoActionNeeded'
  >;
  template?: Array<string>;
  isDesignReady?: boolean;
  payoutState?: Array<'StandardPayout' | 'FullPayout' | 'DefinedPayoutEndOfFiscalYear' | 'NoPayout' | 'Irrelevant'>;
  lineManagerName?: string;
  lineManagerGid?: Array<string>;
  seasonId2?: string;
  workflowInstanceState?: Array<
    | 'None'
    | 'InManagerReview'
    | 'ManagerValidated'
    | 'ReviewPeriodClosed'
    | 'Transferred'
    | 'ManagerRejected'
    | 'InAllocation'
    | 'AllocationFinished'
  >;
  multiplier?: number;
  overallTargetAchievement?: number;
  payoutAmount?: number;
  payoutCurrency?: Array<string>;
  ippAchievementValue?: string;
  incentivePaymentType?: Array<string>;
  meritTitle?: Array<string>;
  equityTitle?: Array<string>;
  equitySubTitle?: Array<string>;
  manuallyChanged?: Array<'None' | 'Activated' | 'Deactivated'>;
  newHire?: Array<'None' | 'Approved' | 'Reviewed' | 'ForReview' | 'Rejected'>;
  promotion?: Array<'None' | 'Requested' | 'InProgress' | 'Rejected' | 'Finalized' | 'RequestedCb'>;
  termination?: Array<'None' | 'ForReview' | 'Rejected' | 'Finalized'>;
  populationChange?: Array<'None' | 'MeritPopulation' | 'EquityPopulation'>;
  lineManagerFirstName?: Array<string>;
  lineManagerLastName?: Array<string>;
  companyManagerFirstName?: Array<string>;
  companyManagerGid?: Array<string>;
  companyManagerLastName?: Array<string>;
  templateName?: Array<string>;
  workflowType?: Array<
    | 'EmployeeConfirmation'
    | 'EmployeeSignature'
    | 'ManagerConfirmationEmployeeConfirmation'
    | 'ManagerConfirmationEmployeeSignature'
    | 'ManagerSignatureEmployeeConfirmation'
    | 'ManagerSignatureEmployeeSignature'
    | 'ManagerConfirmationEmployeeNoActionNeeded'
    | 'NoActionNeeded'
    | 'AllocationByInCompanyManagerInvisibleForLineManager'
    | 'AllocationByInCompanyManagerVisibleForLineManager'
    | 'AllocationByLineManagerApprovalByInCompanyManager'
    | 'AllocationByLineManagerVisibleForInCompanyManager'
    | 'BusinessPartnerConfirmationManagerConfirmationEmployeeConfirmation'
    | 'BusinessPartnerConfirmationManagerConfirmationEmployeeSignature'
    | 'BusinessPartnerConfirmationManagerSignatureEmployeeConfirmation'
    | 'BusinessPartnerConfirmationManagerSignatureEmployeeSignature'
    | 'BusinessPartnerConfirmationManagerConfirmationEmployeeNoActionNeeded'
    | 'BusinessPartnerConfirmationManagerSignatureEmployeeNoActionNeeded'
    | 'BusinessPartnerSignatureManagerConfirmationEmployeeConfirmation'
    | 'BusinessPartnerSignatureManagerConfirmationEmployeeSignature'
    | 'BusinessPartnerSignatureManagerSignatureEmployeeConfirmation'
    | 'BusinessPartnerSignatureManagerSignatureEmployeeSignature'
    | 'BusinessPartnerSignatureManagerConfirmationEmployeeNoActionNeeded'
    | 'BusinessPartnerSignatureManagerSignatureEmployeeNoActionNeeded'
  >;
  autoApprove?: boolean;
  approvalRequired?: boolean;
  letterState?: Array<
    | 'None'
    | 'Created'
    | 'InManagerReview'
    | 'InEmployeeReview'
    | 'Published'
    | 'ManagerRejected'
    | 'EmployeeRejected'
    | 'NoTafRequired'
    | 'InBusinessPartnerReview'
    | 'BusinessPartnerRejected'
  >;
  processState?: Array<
    | 'None'
    | 'Created'
    | 'InManagerReview'
    | 'InEmployeeReview'
    | 'Published'
    | 'ManagerRejected'
    | 'EmployeeRejected'
    | 'NoTafRequired'
    | 'InBusinessPartnerReview'
    | 'BusinessPartnerRejected'
  >;
  exportState?: Array<'Open' | 'Done'>;
  payrollState?: Array<'Open' | 'Done'>;
  meritRelevancy?: Array<'Relevant' | 'Excluded' | 'NoIncrease'>;
  approvedByCompanyManager?: boolean;
  allocationWorkflowType?: Array<
    | 'EmployeeConfirmation'
    | 'EmployeeSignature'
    | 'ManagerConfirmationEmployeeConfirmation'
    | 'ManagerConfirmationEmployeeSignature'
    | 'ManagerSignatureEmployeeConfirmation'
    | 'ManagerSignatureEmployeeSignature'
    | 'ManagerConfirmationEmployeeNoActionNeeded'
    | 'NoActionNeeded'
    | 'AllocationByInCompanyManagerInvisibleForLineManager'
    | 'AllocationByInCompanyManagerVisibleForLineManager'
    | 'AllocationByLineManagerApprovalByInCompanyManager'
    | 'AllocationByLineManagerVisibleForInCompanyManager'
    | 'BusinessPartnerConfirmationManagerConfirmationEmployeeConfirmation'
    | 'BusinessPartnerConfirmationManagerConfirmationEmployeeSignature'
    | 'BusinessPartnerConfirmationManagerSignatureEmployeeConfirmation'
    | 'BusinessPartnerConfirmationManagerSignatureEmployeeSignature'
    | 'BusinessPartnerConfirmationManagerConfirmationEmployeeNoActionNeeded'
    | 'BusinessPartnerConfirmationManagerSignatureEmployeeNoActionNeeded'
    | 'BusinessPartnerSignatureManagerConfirmationEmployeeConfirmation'
    | 'BusinessPartnerSignatureManagerConfirmationEmployeeSignature'
    | 'BusinessPartnerSignatureManagerSignatureEmployeeConfirmation'
    | 'BusinessPartnerSignatureManagerSignatureEmployeeSignature'
    | 'BusinessPartnerSignatureManagerConfirmationEmployeeNoActionNeeded'
    | 'BusinessPartnerSignatureManagerSignatureEmployeeNoActionNeeded'
  >;
  readyToPayroll?: boolean;
  equityRelevancy?: Array<'Relevant' | 'Excluded' | 'NoIncrease'>;
  hasOtpIncrease?: boolean;
  isOtpOnly?: boolean;
  planTitle?: Array<string>;
  localCurrency?: Array<string>;
  proposalAmount?: number;
  proposalDate?: string;
  specialPaymentReason?: Array<'Unknown' | 'SpecialProjectsInvolvement' | 'TemporaryEnlargedScope'>;
  proposalState?: Array<'Unknown' | 'Pending' | 'Approved' | 'AutoApproved' | 'Rejected'>;
  templateLetterName?: Array<string>;
  measurementDate?: string;
  calculateManyProrations?: CalculateManyProrations;
}

export interface IncentivePartnerCalculateProrationRecordCalculationsParams {
  seasonId: string;
  recordId: string;
}

export interface IncentivePartnerCreateManualReassignmentsParams {
  seasonId: string;
  createManualReassignment?: CreateManualReassignment;
}

export interface IncentivePartnerGetReassignmentsParams {
  seasonId: string;
  id: string;
}

export interface IncentivePartnerGetRecordsParams {
  id: string;
  seasonId: string;
}

export interface IncentivePartnerGetSeasonsParams {
  id: string;
}

export interface IncentivePartnerQueryFieldValuesReassignmentsParams {
  seasonId: string;
  targetProperty?: 0 | 1 | 2 | 3 | 4 | 5 | 6 | 7 | 8 | 9 | 10 | 11 | 12 | 13 | 14;
  plan?: string;
  country?: string;
  are?: string;
  orgCluster?: string;
  managementType?: string;
  iPT?: string;
  newPlan?: string;
  newCountry?: string;
  newAre?: string;
  newOrgCluster?: string;
  newManagementType?: string;
  newIPT?: string;
  reason?: string;
  state?: string;
  orgCodeNew?: string;
  orgCodeCurrent?: string;
  page?: number;
  size?: number;
}

export interface IncentivePartnerQueryFieldValuesRecordsParams {
  seasonId: string;
  targetProperty?: 0 | 1 | 2 | 3 | 4 | 5 | 6 | 7 | 8 | 9 | 10 | 11 | 12 | 13 | 14 | 15 | 16;
  assignmentId?: string;
  gid?: string;
  firstname?: string;
  lastname?: string;
  are?: string;
  country?: string;
  orgCode?: string;
  planName?: string;
  letterState?: string;
  recordCommunicationStates?: string;
  processStates?: string;
  template?: string;
  workflow?: string;
  payoutState?: string;
  exportState?: string;
  incentivePaymentType?: string;
  contractStatus?: string;
  page?: number;
  size?: number;
}

export interface IncentivePartnerQueryPlansParams {
  seasonId: string;
  page?: number;
  size?: number;
  orderBy?: 'Asc' | 'Desc';
  property?: string;
  title?: string;
  displayName?: string;
}

export interface IncentivePartnerQueryReassignmentsParams {
  seasonId: string;
  querySearch?: string;
  queryTargetProperty?:
    | 0
    | 1
    | 2
    | 3
    | 4
    | 5
    | 6
    | 7
    | 8
    | 9
    | 10
    | 11
    | 12
    | 13
    | 14
    | 15
    | 16
    | 17
    | 18
    | 19
    | 20
    | 21
    | 22
    | 23
    | 24
    | 25
    | 26
    | 27;
  queryId?: string;
  querySeasonId?: string;
  queryGid?: string;
  queryFirstname?: string;
  queryLastname?: string;
  queryReason?: Array<string>;
  queryStartDate?: string;
  queryEndDate?: string;
  queryAction?: 'Nothing' | 'AssignNew' | 'TerminateAndReassign' | 'Terminate';
  queryState?: 'Unknown' | 'Created' | 'Accepted' | 'Rejected' | 'Deactivated';
  queryAreNew?: Array<string>;
  queryAreCurrent?: Array<string>;
  queryCountryNew?: Array<string>;
  queryCountryCurrent?: Array<string>;
  queryOrgCodeNew?: Array<string>;
  queryOrgCodeCurrent?: Array<string>;
  queryPlanNameNew?: Array<string>;
  queryPlanNameCurrent?: Array<string>;
  queryTargetIncentiveAmountCurrent?: number;
  queryTargetIncentiveAmountNew?: number;
  queryIncentivePaymentTypeCurrent?: Array<string>;
  queryIncentivePaymentTypeNew?: Array<string>;
  queryOrgClusterCurrent?: Array<string>;
  queryOrgClusterNew?: Array<string>;
  queryManagementType?: Array<string>;
  queryNewManagementType?: Array<string>;
  pagingPage?: number;
  pagingSize?: number;
  sortingOrderBy?: 'Asc' | 'Desc';
  sortingProperty?: string;
}

export interface IncentivePartnerQueryRecordsParams {
  seasonId: string;
  employeeId?: string;
  recordState?: Array<'Active' | 'Draft' | 'Outdated' | 'Irrelevant'>;
  queryId?: Array<string>;
  queryGid?: Array<string>;
  queryFirstName?: Array<string>;
  queryLastName?: Array<string>;
  queryCountry?: Array<string>;
  queryAre?: Array<string>;
  queryOrgCode?: Array<string>;
  queryPlanName?: Array<string>;
  queryState?: Array<'Active' | 'Draft' | 'Outdated' | 'Irrelevant'>;
  queryStartDate?: string;
  queryEndDate?: string;
  queryPayoutDate?: string;
  queryAssignmentManager?: string;
  queryAssignmentId?: string;
  queryLetterType?:
    | 'Other'
    | 'AdherenceLetter'
    | 'TargetAgreementForm'
    | 'TargetAchievementForm'
    | 'MeritAllocation'
    | 'SpecialRecognitionLetter'
    | 'RestructuringCalculation'
    | 'RestructuringLetter';
  queryProcessStates?: Array<
    | 'None'
    | 'Open'
    | 'TafCreated'
    | 'TafPublished'
    | 'ReadyForCalculation'
    | 'Calculated'
    | 'Frozen'
    | 'AchievementLetterCreated'
    | 'AchievementLetterPublished'
  >;
  queryRecordCommunicationStates?: Array<
    | 'None'
    | 'Created'
    | 'InManagerReview'
    | 'InEmployeeReview'
    | 'Published'
    | 'ManagerRejected'
    | 'EmployeeRejected'
    | 'NoLetterRequired'
  >;
  queryWorkflow?: Array<
    | 'EmployeeConfirmation'
    | 'EmployeeSignature'
    | 'ManagerConfirmationEmployeeConfirmation'
    | 'ManagerConfirmationEmployeeSignature'
    | 'ManagerSignatureEmployeeConfirmation'
    | 'ManagerSignatureEmployeeSignature'
    | 'ManagerConfirmationEmployeeNoActionNeeded'
    | 'NoActionNeeded'
    | 'AllocationByInCompanyManagerInvisibleForLineManager'
    | 'AllocationByInCompanyManagerVisibleForLineManager'
    | 'AllocationByLineManagerApprovalByInCompanyManager'
    | 'AllocationByLineManagerVisibleForInCompanyManager'
    | 'BusinessPartnerConfirmationManagerConfirmationEmployeeConfirmation'
    | 'BusinessPartnerConfirmationManagerConfirmationEmployeeSignature'
    | 'BusinessPartnerConfirmationManagerSignatureEmployeeConfirmation'
    | 'BusinessPartnerConfirmationManagerSignatureEmployeeSignature'
    | 'BusinessPartnerConfirmationManagerConfirmationEmployeeNoActionNeeded'
    | 'BusinessPartnerConfirmationManagerSignatureEmployeeNoActionNeeded'
    | 'BusinessPartnerSignatureManagerConfirmationEmployeeConfirmation'
    | 'BusinessPartnerSignatureManagerConfirmationEmployeeSignature'
    | 'BusinessPartnerSignatureManagerSignatureEmployeeConfirmation'
    | 'BusinessPartnerSignatureManagerSignatureEmployeeSignature'
    | 'BusinessPartnerSignatureManagerConfirmationEmployeeNoActionNeeded'
    | 'BusinessPartnerSignatureManagerSignatureEmployeeNoActionNeeded'
  >;
  queryTemplate?: Array<string>;
  queryIsDesignReady?: boolean;
  queryPayoutState?: Array<
    'StandardPayout' | 'FullPayout' | 'DefinedPayoutEndOfFiscalYear' | 'NoPayout' | 'Irrelevant'
  >;
  queryLineManagerName?: string;
  queryLineManagerGid?: Array<string>;
  querySeasonId?: string;
  queryWorkflowInstanceState?: Array<
    | 'None'
    | 'InManagerReview'
    | 'ManagerValidated'
    | 'ReviewPeriodClosed'
    | 'Transferred'
    | 'ManagerRejected'
    | 'InAllocation'
    | 'AllocationFinished'
  >;
  queryMultiplier?: number;
  queryOverallTargetAchievement?: number;
  queryPayoutAmount?: number;
  queryPayoutCurrency?: Array<string>;
  queryIppAchievementValue?: string;
  queryIncentivePaymentType?: Array<string>;
  queryMeritTitle?: Array<string>;
  queryEquityTitle?: Array<string>;
  queryEquitySubTitle?: Array<string>;
  queryManuallyChanged?: Array<'None' | 'Activated' | 'Deactivated'>;
  queryNewHire?: Array<'None' | 'Approved' | 'Reviewed' | 'ForReview' | 'Rejected'>;
  queryPromotion?: Array<'None' | 'Requested' | 'InProgress' | 'Rejected' | 'Finalized' | 'RequestedCb'>;
  queryTermination?: Array<'None' | 'ForReview' | 'Rejected' | 'Finalized'>;
  queryPopulationChange?: Array<'None' | 'MeritPopulation' | 'EquityPopulation'>;
  queryLineManagerFirstName?: Array<string>;
  queryLineManagerLastName?: Array<string>;
  queryCompanyManagerFirstName?: Array<string>;
  queryCompanyManagerGid?: Array<string>;
  queryCompanyManagerLastName?: Array<string>;
  queryTemplateName?: Array<string>;
  queryWorkflowType?: Array<
    | 'EmployeeConfirmation'
    | 'EmployeeSignature'
    | 'ManagerConfirmationEmployeeConfirmation'
    | 'ManagerConfirmationEmployeeSignature'
    | 'ManagerSignatureEmployeeConfirmation'
    | 'ManagerSignatureEmployeeSignature'
    | 'ManagerConfirmationEmployeeNoActionNeeded'
    | 'NoActionNeeded'
    | 'AllocationByInCompanyManagerInvisibleForLineManager'
    | 'AllocationByInCompanyManagerVisibleForLineManager'
    | 'AllocationByLineManagerApprovalByInCompanyManager'
    | 'AllocationByLineManagerVisibleForInCompanyManager'
    | 'BusinessPartnerConfirmationManagerConfirmationEmployeeConfirmation'
    | 'BusinessPartnerConfirmationManagerConfirmationEmployeeSignature'
    | 'BusinessPartnerConfirmationManagerSignatureEmployeeConfirmation'
    | 'BusinessPartnerConfirmationManagerSignatureEmployeeSignature'
    | 'BusinessPartnerConfirmationManagerConfirmationEmployeeNoActionNeeded'
    | 'BusinessPartnerConfirmationManagerSignatureEmployeeNoActionNeeded'
    | 'BusinessPartnerSignatureManagerConfirmationEmployeeConfirmation'
    | 'BusinessPartnerSignatureManagerConfirmationEmployeeSignature'
    | 'BusinessPartnerSignatureManagerSignatureEmployeeConfirmation'
    | 'BusinessPartnerSignatureManagerSignatureEmployeeSignature'
    | 'BusinessPartnerSignatureManagerConfirmationEmployeeNoActionNeeded'
    | 'BusinessPartnerSignatureManagerSignatureEmployeeNoActionNeeded'
  >;
  queryAutoApprove?: boolean;
  queryApprovalRequired?: boolean;
  queryLetterState?: Array<
    | 'None'
    | 'Created'
    | 'InManagerReview'
    | 'InEmployeeReview'
    | 'Published'
    | 'ManagerRejected'
    | 'EmployeeRejected'
    | 'NoTafRequired'
    | 'InBusinessPartnerReview'
    | 'BusinessPartnerRejected'
  >;
  queryProcessState?: Array<
    | 'None'
    | 'Created'
    | 'InManagerReview'
    | 'InEmployeeReview'
    | 'Published'
    | 'ManagerRejected'
    | 'EmployeeRejected'
    | 'NoTafRequired'
    | 'InBusinessPartnerReview'
    | 'BusinessPartnerRejected'
  >;
  queryExportState?: Array<'Open' | 'Done'>;
  queryPayrollState?: Array<'Open' | 'Done'>;
  queryMeritRelevancy?: Array<'Relevant' | 'Excluded' | 'NoIncrease'>;
  queryApprovedByCompanyManager?: boolean;
  queryAllocationWorkflowType?: Array<
    | 'EmployeeConfirmation'
    | 'EmployeeSignature'
    | 'ManagerConfirmationEmployeeConfirmation'
    | 'ManagerConfirmationEmployeeSignature'
    | 'ManagerSignatureEmployeeConfirmation'
    | 'ManagerSignatureEmployeeSignature'
    | 'ManagerConfirmationEmployeeNoActionNeeded'
    | 'NoActionNeeded'
    | 'AllocationByInCompanyManagerInvisibleForLineManager'
    | 'AllocationByInCompanyManagerVisibleForLineManager'
    | 'AllocationByLineManagerApprovalByInCompanyManager'
    | 'AllocationByLineManagerVisibleForInCompanyManager'
    | 'BusinessPartnerConfirmationManagerConfirmationEmployeeConfirmation'
    | 'BusinessPartnerConfirmationManagerConfirmationEmployeeSignature'
    | 'BusinessPartnerConfirmationManagerSignatureEmployeeConfirmation'
    | 'BusinessPartnerConfirmationManagerSignatureEmployeeSignature'
    | 'BusinessPartnerConfirmationManagerConfirmationEmployeeNoActionNeeded'
    | 'BusinessPartnerConfirmationManagerSignatureEmployeeNoActionNeeded'
    | 'BusinessPartnerSignatureManagerConfirmationEmployeeConfirmation'
    | 'BusinessPartnerSignatureManagerConfirmationEmployeeSignature'
    | 'BusinessPartnerSignatureManagerSignatureEmployeeConfirmation'
    | 'BusinessPartnerSignatureManagerSignatureEmployeeSignature'
    | 'BusinessPartnerSignatureManagerConfirmationEmployeeNoActionNeeded'
    | 'BusinessPartnerSignatureManagerSignatureEmployeeNoActionNeeded'
  >;
  queryReadyToPayroll?: boolean;
  queryEquityRelevancy?: Array<'Relevant' | 'Excluded' | 'NoIncrease'>;
  queryHasOtpIncrease?: boolean;
  queryIsOtpOnly?: boolean;
  queryPlanTitle?: Array<string>;
  queryLocalCurrency?: Array<string>;
  queryProposalAmount?: number;
  queryProposalDate?: string;
  querySpecialPaymentReason?: Array<'Unknown' | 'SpecialProjectsInvolvement' | 'TemporaryEnlargedScope'>;
  queryProposalState?: Array<'Unknown' | 'Pending' | 'Approved' | 'AutoApproved' | 'Rejected'>;
  queryTemplateLetterName?: Array<string>;
  queryMeasurementDate?: string;
  pagingPage?: number;
  pagingSize?: number;
  sortingOrderBy?: 'Asc' | 'Desc';
  sortingProperty?: string;
}

export interface IncentivePartnerQuerySeasonsParams {
  page?: number;
  size?: number;
  orderBy?: 'Asc' | 'Desc';
  property?: string;
}

export interface IncentivePartnerRejectManyReassignmentAcknowledgementsParams {
  seasonId: string;
  search?: string;
  targetProperty?:
    | 0
    | 1
    | 2
    | 3
    | 4
    | 5
    | 6
    | 7
    | 8
    | 9
    | 10
    | 11
    | 12
    | 13
    | 14
    | 15
    | 16
    | 17
    | 18
    | 19
    | 20
    | 21
    | 22
    | 23
    | 24
    | 25
    | 26
    | 27;
  id?: string;
  seasonId2?: string;
  gid?: string;
  firstname?: string;
  lastname?: string;
  reason?: Array<string>;
  startDate?: string;
  endDate?: string;
  action?: 'Nothing' | 'AssignNew' | 'TerminateAndReassign' | 'Terminate';
  state?: 'Unknown' | 'Created' | 'Accepted' | 'Rejected' | 'Deactivated';
  areNew?: Array<string>;
  areCurrent?: Array<string>;
  countryNew?: Array<string>;
  countryCurrent?: Array<string>;
  orgCodeNew?: Array<string>;
  orgCodeCurrent?: Array<string>;
  planNameNew?: Array<string>;
  planNameCurrent?: Array<string>;
  targetIncentiveAmountCurrent?: number;
  targetIncentiveAmountNew?: number;
  incentivePaymentTypeCurrent?: Array<string>;
  incentivePaymentTypeNew?: Array<string>;
  orgClusterCurrent?: Array<string>;
  orgClusterNew?: Array<string>;
  managementType?: Array<string>;
  newManagementType?: Array<string>;
  acknowledgeManyReassignmentsPartner?: AcknowledgeManyReassignmentsPartner;
}

export interface IncentivePartnerRejectReassignmentAcknowledgementsParams {
  reassignmentId: string;
  seasonId: string;
}

export interface IncentivePartnerUpdateEmployeeSnapshotsParams {
  seasonId: string;
  recordId: string;
  id: string;
  updateEmployeeSnapshotPartner?: UpdateEmployeeSnapshotPartner;
}

export interface IncentivePartnerUpdateReassignmentsParams {
  id: string;
  seasonId: string;
  updateReassignment?: UpdateReassignment;
}

export interface IncentivePartnerUpdateRecordIndividualMultiplierValueRecordsParams {
  seasonId: string;
  id: string;
  updateRecordIndividualMultiplierValuePartner?: UpdateRecordIndividualMultiplierValuePartner;
}

export interface IncentivePartnerUpdateRecordStatesRecordsParams {
  seasonId: string;
  id?: Array<string>;
  gid?: Array<string>;
  firstName?: Array<string>;
  lastName?: Array<string>;
  country?: Array<string>;
  are?: Array<string>;
  orgCode?: Array<string>;
  planName?: Array<string>;
  state?: Array<'Active' | 'Draft' | 'Outdated' | 'Irrelevant'>;
  startDate?: string;
  endDate?: string;
  payoutDate?: string;
  assignmentManager?: string;
  assignmentId?: string;
  letterType?:
    | 'Other'
    | 'AdherenceLetter'
    | 'TargetAgreementForm'
    | 'TargetAchievementForm'
    | 'MeritAllocation'
    | 'SpecialRecognitionLetter'
    | 'RestructuringCalculation'
    | 'RestructuringLetter';
  processStates?: Array<
    | 'None'
    | 'Open'
    | 'TafCreated'
    | 'TafPublished'
    | 'ReadyForCalculation'
    | 'Calculated'
    | 'Frozen'
    | 'AchievementLetterCreated'
    | 'AchievementLetterPublished'
  >;
  recordCommunicationStates?: Array<
    | 'None'
    | 'Created'
    | 'InManagerReview'
    | 'InEmployeeReview'
    | 'Published'
    | 'ManagerRejected'
    | 'EmployeeRejected'
    | 'NoLetterRequired'
  >;
  workflow?: Array<
    | 'EmployeeConfirmation'
    | 'EmployeeSignature'
    | 'ManagerConfirmationEmployeeConfirmation'
    | 'ManagerConfirmationEmployeeSignature'
    | 'ManagerSignatureEmployeeConfirmation'
    | 'ManagerSignatureEmployeeSignature'
    | 'ManagerConfirmationEmployeeNoActionNeeded'
    | 'NoActionNeeded'
    | 'AllocationByInCompanyManagerInvisibleForLineManager'
    | 'AllocationByInCompanyManagerVisibleForLineManager'
    | 'AllocationByLineManagerApprovalByInCompanyManager'
    | 'AllocationByLineManagerVisibleForInCompanyManager'
    | 'BusinessPartnerConfirmationManagerConfirmationEmployeeConfirmation'
    | 'BusinessPartnerConfirmationManagerConfirmationEmployeeSignature'
    | 'BusinessPartnerConfirmationManagerSignatureEmployeeConfirmation'
    | 'BusinessPartnerConfirmationManagerSignatureEmployeeSignature'
    | 'BusinessPartnerConfirmationManagerConfirmationEmployeeNoActionNeeded'
    | 'BusinessPartnerConfirmationManagerSignatureEmployeeNoActionNeeded'
    | 'BusinessPartnerSignatureManagerConfirmationEmployeeConfirmation'
    | 'BusinessPartnerSignatureManagerConfirmationEmployeeSignature'
    | 'BusinessPartnerSignatureManagerSignatureEmployeeConfirmation'
    | 'BusinessPartnerSignatureManagerSignatureEmployeeSignature'
    | 'BusinessPartnerSignatureManagerConfirmationEmployeeNoActionNeeded'
    | 'BusinessPartnerSignatureManagerSignatureEmployeeNoActionNeeded'
  >;
  template?: Array<string>;
  isDesignReady?: boolean;
  payoutState?: Array<'StandardPayout' | 'FullPayout' | 'DefinedPayoutEndOfFiscalYear' | 'NoPayout' | 'Irrelevant'>;
  lineManagerName?: string;
  lineManagerGid?: Array<string>;
  seasonId2?: string;
  workflowInstanceState?: Array<
    | 'None'
    | 'InManagerReview'
    | 'ManagerValidated'
    | 'ReviewPeriodClosed'
    | 'Transferred'
    | 'ManagerRejected'
    | 'InAllocation'
    | 'AllocationFinished'
  >;
  multiplier?: number;
  overallTargetAchievement?: number;
  payoutAmount?: number;
  payoutCurrency?: Array<string>;
  ippAchievementValue?: string;
  incentivePaymentType?: Array<string>;
  meritTitle?: Array<string>;
  equityTitle?: Array<string>;
  equitySubTitle?: Array<string>;
  manuallyChanged?: Array<'None' | 'Activated' | 'Deactivated'>;
  newHire?: Array<'None' | 'Approved' | 'Reviewed' | 'ForReview' | 'Rejected'>;
  promotion?: Array<'None' | 'Requested' | 'InProgress' | 'Rejected' | 'Finalized' | 'RequestedCb'>;
  termination?: Array<'None' | 'ForReview' | 'Rejected' | 'Finalized'>;
  populationChange?: Array<'None' | 'MeritPopulation' | 'EquityPopulation'>;
  lineManagerFirstName?: Array<string>;
  lineManagerLastName?: Array<string>;
  companyManagerFirstName?: Array<string>;
  companyManagerGid?: Array<string>;
  companyManagerLastName?: Array<string>;
  templateName?: Array<string>;
  workflowType?: Array<
    | 'EmployeeConfirmation'
    | 'EmployeeSignature'
    | 'ManagerConfirmationEmployeeConfirmation'
    | 'ManagerConfirmationEmployeeSignature'
    | 'ManagerSignatureEmployeeConfirmation'
    | 'ManagerSignatureEmployeeSignature'
    | 'ManagerConfirmationEmployeeNoActionNeeded'
    | 'NoActionNeeded'
    | 'AllocationByInCompanyManagerInvisibleForLineManager'
    | 'AllocationByInCompanyManagerVisibleForLineManager'
    | 'AllocationByLineManagerApprovalByInCompanyManager'
    | 'AllocationByLineManagerVisibleForInCompanyManager'
    | 'BusinessPartnerConfirmationManagerConfirmationEmployeeConfirmation'
    | 'BusinessPartnerConfirmationManagerConfirmationEmployeeSignature'
    | 'BusinessPartnerConfirmationManagerSignatureEmployeeConfirmation'
    | 'BusinessPartnerConfirmationManagerSignatureEmployeeSignature'
    | 'BusinessPartnerConfirmationManagerConfirmationEmployeeNoActionNeeded'
    | 'BusinessPartnerConfirmationManagerSignatureEmployeeNoActionNeeded'
    | 'BusinessPartnerSignatureManagerConfirmationEmployeeConfirmation'
    | 'BusinessPartnerSignatureManagerConfirmationEmployeeSignature'
    | 'BusinessPartnerSignatureManagerSignatureEmployeeConfirmation'
    | 'BusinessPartnerSignatureManagerSignatureEmployeeSignature'
    | 'BusinessPartnerSignatureManagerConfirmationEmployeeNoActionNeeded'
    | 'BusinessPartnerSignatureManagerSignatureEmployeeNoActionNeeded'
  >;
  autoApprove?: boolean;
  approvalRequired?: boolean;
  letterState?: Array<
    | 'None'
    | 'Created'
    | 'InManagerReview'
    | 'InEmployeeReview'
    | 'Published'
    | 'ManagerRejected'
    | 'EmployeeRejected'
    | 'NoTafRequired'
    | 'InBusinessPartnerReview'
    | 'BusinessPartnerRejected'
  >;
  processState?: Array<
    | 'None'
    | 'Created'
    | 'InManagerReview'
    | 'InEmployeeReview'
    | 'Published'
    | 'ManagerRejected'
    | 'EmployeeRejected'
    | 'NoTafRequired'
    | 'InBusinessPartnerReview'
    | 'BusinessPartnerRejected'
  >;
  exportState?: Array<'Open' | 'Done'>;
  payrollState?: Array<'Open' | 'Done'>;
  meritRelevancy?: Array<'Relevant' | 'Excluded' | 'NoIncrease'>;
  approvedByCompanyManager?: boolean;
  allocationWorkflowType?: Array<
    | 'EmployeeConfirmation'
    | 'EmployeeSignature'
    | 'ManagerConfirmationEmployeeConfirmation'
    | 'ManagerConfirmationEmployeeSignature'
    | 'ManagerSignatureEmployeeConfirmation'
    | 'ManagerSignatureEmployeeSignature'
    | 'ManagerConfirmationEmployeeNoActionNeeded'
    | 'NoActionNeeded'
    | 'AllocationByInCompanyManagerInvisibleForLineManager'
    | 'AllocationByInCompanyManagerVisibleForLineManager'
    | 'AllocationByLineManagerApprovalByInCompanyManager'
    | 'AllocationByLineManagerVisibleForInCompanyManager'
    | 'BusinessPartnerConfirmationManagerConfirmationEmployeeConfirmation'
    | 'BusinessPartnerConfirmationManagerConfirmationEmployeeSignature'
    | 'BusinessPartnerConfirmationManagerSignatureEmployeeConfirmation'
    | 'BusinessPartnerConfirmationManagerSignatureEmployeeSignature'
    | 'BusinessPartnerConfirmationManagerConfirmationEmployeeNoActionNeeded'
    | 'BusinessPartnerConfirmationManagerSignatureEmployeeNoActionNeeded'
    | 'BusinessPartnerSignatureManagerConfirmationEmployeeConfirmation'
    | 'BusinessPartnerSignatureManagerConfirmationEmployeeSignature'
    | 'BusinessPartnerSignatureManagerSignatureEmployeeConfirmation'
    | 'BusinessPartnerSignatureManagerSignatureEmployeeSignature'
    | 'BusinessPartnerSignatureManagerConfirmationEmployeeNoActionNeeded'
    | 'BusinessPartnerSignatureManagerSignatureEmployeeNoActionNeeded'
  >;
  readyToPayroll?: boolean;
  equityRelevancy?: Array<'Relevant' | 'Excluded' | 'NoIncrease'>;
  hasOtpIncrease?: boolean;
  isOtpOnly?: boolean;
  planTitle?: Array<string>;
  localCurrency?: Array<string>;
  proposalAmount?: number;
  proposalDate?: string;
  specialPaymentReason?: Array<'Unknown' | 'SpecialProjectsInvolvement' | 'TemporaryEnlargedScope'>;
  proposalState?: Array<'Unknown' | 'Pending' | 'Approved' | 'AutoApproved' | 'Rejected'>;
  templateLetterName?: Array<string>;
  measurementDate?: string;
  updateManyRecordStatesPartner?: UpdateManyRecordStatesPartner;
}

export interface IncentivePartnerUpdateRecordsParams {
  seasonId: string;
  id: string;
  updateRecordPartner?: UpdateRecordPartner;
}

export interface QueryCommentsRecordsParams {
  recordId: string;
  seasonId: string;
  page?: number;
  size?: number;
}

export interface QueryDashboardMonitoringParams {
  seasonId: string;
}

export interface QueryFieldValuesMonitoringParams {
  seasonId: string;
  targetProperty?: 0 | 1 | 2 | 3 | 4 | 5 | 6 | 7 | 8 | 9 | 10 | 11 | 12 | 13 | 14 | 15 | 16;
  assignmentId?: string;
  gid?: string;
  firstname?: string;
  lastname?: string;
  are?: string;
  country?: string;
  orgCode?: string;
  planName?: string;
  letterState?: string;
  recordCommunicationStates?: string;
  processStates?: string;
  template?: string;
  workflow?: string;
  payoutState?: string;
  exportState?: string;
  incentivePaymentType?: string;
  contractStatus?: string;
  page?: number;
  size?: number;
}

export interface QueryMonitoringParams {
  seasonId: string;
  employeeId?: string;
  recordState?: Array<'Active' | 'Draft' | 'Outdated' | 'Irrelevant'>;
  queryId?: Array<string>;
  queryGid?: Array<string>;
  queryFirstName?: Array<string>;
  queryLastName?: Array<string>;
  queryCountry?: Array<string>;
  queryAre?: Array<string>;
  queryOrgCode?: Array<string>;
  queryPlanName?: Array<string>;
  queryState?: Array<'Active' | 'Draft' | 'Outdated' | 'Irrelevant'>;
  queryStartDate?: string;
  queryEndDate?: string;
  queryPayoutDate?: string;
  queryAssignmentManager?: string;
  queryAssignmentId?: string;
  queryLetterType?:
    | 'Other'
    | 'AdherenceLetter'
    | 'TargetAgreementForm'
    | 'TargetAchievementForm'
    | 'MeritAllocation'
    | 'SpecialRecognitionLetter'
    | 'RestructuringCalculation'
    | 'RestructuringLetter';
  queryProcessStates?: Array<
    | 'None'
    | 'Open'
    | 'TafCreated'
    | 'TafPublished'
    | 'ReadyForCalculation'
    | 'Calculated'
    | 'Frozen'
    | 'AchievementLetterCreated'
    | 'AchievementLetterPublished'
  >;
  queryRecordCommunicationStates?: Array<
    | 'None'
    | 'Created'
    | 'InManagerReview'
    | 'InEmployeeReview'
    | 'Published'
    | 'ManagerRejected'
    | 'EmployeeRejected'
    | 'NoLetterRequired'
  >;
  queryWorkflow?: Array<
    | 'EmployeeConfirmation'
    | 'EmployeeSignature'
    | 'ManagerConfirmationEmployeeConfirmation'
    | 'ManagerConfirmationEmployeeSignature'
    | 'ManagerSignatureEmployeeConfirmation'
    | 'ManagerSignatureEmployeeSignature'
    | 'ManagerConfirmationEmployeeNoActionNeeded'
    | 'NoActionNeeded'
    | 'AllocationByInCompanyManagerInvisibleForLineManager'
    | 'AllocationByInCompanyManagerVisibleForLineManager'
    | 'AllocationByLineManagerApprovalByInCompanyManager'
    | 'AllocationByLineManagerVisibleForInCompanyManager'
    | 'BusinessPartnerConfirmationManagerConfirmationEmployeeConfirmation'
    | 'BusinessPartnerConfirmationManagerConfirmationEmployeeSignature'
    | 'BusinessPartnerConfirmationManagerSignatureEmployeeConfirmation'
    | 'BusinessPartnerConfirmationManagerSignatureEmployeeSignature'
    | 'BusinessPartnerConfirmationManagerConfirmationEmployeeNoActionNeeded'
    | 'BusinessPartnerConfirmationManagerSignatureEmployeeNoActionNeeded'
    | 'BusinessPartnerSignatureManagerConfirmationEmployeeConfirmation'
    | 'BusinessPartnerSignatureManagerConfirmationEmployeeSignature'
    | 'BusinessPartnerSignatureManagerSignatureEmployeeConfirmation'
    | 'BusinessPartnerSignatureManagerSignatureEmployeeSignature'
    | 'BusinessPartnerSignatureManagerConfirmationEmployeeNoActionNeeded'
    | 'BusinessPartnerSignatureManagerSignatureEmployeeNoActionNeeded'
  >;
  queryTemplate?: Array<string>;
  queryIsDesignReady?: boolean;
  queryPayoutState?: Array<
    'StandardPayout' | 'FullPayout' | 'DefinedPayoutEndOfFiscalYear' | 'NoPayout' | 'Irrelevant'
  >;
  queryManagerSetMercerJobCode?: Array<string>;
  queryEditedMercerJobCode?: Array<string>;
  queryCurrentMercerJobCode?: Array<string>;
  queryIsMercerJobCodeValid?: boolean;
  queryIsGripCodeValid?: boolean;
  queryLineManagerName?: string;
  queryLineManagerGid?: Array<string>;
  querySeasonId?: string;
  queryWorkflowInstanceState?: Array<
    | 'None'
    | 'InManagerReview'
    | 'ManagerValidated'
    | 'ReviewPeriodClosed'
    | 'Transferred'
    | 'ManagerRejected'
    | 'InAllocation'
    | 'AllocationFinished'
  >;
  queryMultiplier?: number;
  queryOverallTargetAchievement?: number;
  queryPayoutAmount?: number;
  queryPayoutCurrency?: Array<string>;
  queryIppAchievementValue?: string;
  queryIncentivePaymentType?: string;
  queryContractStatus?: Array<'Terminated' | 'Dormant' | 'Active' | 'Other'>;
  pagingPage?: number;
  pagingSize?: number;
  sortingOrderBy?: 'Asc' | 'Desc';
  sortingProperty?: string;
}

@Injectable({
  providedIn: 'root'
})
export class IncentivePartnerService extends BaseService {
  constructor(
    httpClient: HttpClient,
    @Optional() @Inject(BASE_PATH) basePath: string | string[],
    @Optional() configuration: Configuration
  ) {
    super(httpClient, basePath, configuration);
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public createCommentRecords(
    requestParameters?: CreateCommentRecordsParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<IncentiveComment>;
  public createCommentRecords(
    requestParameters?: CreateCommentRecordsParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpResponse<IncentiveComment>>;
  public createCommentRecords(
    requestParameters?: CreateCommentRecordsParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpEvent<IncentiveComment>>;
  public createCommentRecords(requestParameters?: CreateCommentRecordsParams, ...args: RequestArgs): Observable<any> {
    const recordId = requestParameters?.recordId;
    const seasonId = requestParameters?.seasonId;
    this.checkRequired('createCommentRecords', { recordId, seasonId });
    return this.sendRequest(args, {
      method: 'post',
      path: `/partner/api/v1/seasons/incentive/${this.configuration.encodeParam({ name: 'seasonId', value: seasonId, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: undefined })}/records/${this.configuration.encodeParam({ name: 'recordId', value: recordId, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: 'uuid' })}/comments`,
      accepts: ['text/plain', 'application/json', 'text/json'],
      body: requestParameters?.createComment,
      consumes: ['application/json-patch+json', 'application/json', 'text/json', 'application/*+json']
    });
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public deleteCommentRecords(
    requestParameters?: DeleteCommentRecordsParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: RequestOptions<undefined>
  ): Observable<any>;
  public deleteCommentRecords(
    requestParameters?: DeleteCommentRecordsParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: RequestOptions<undefined>
  ): Observable<HttpResponse<any>>;
  public deleteCommentRecords(
    requestParameters?: DeleteCommentRecordsParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: RequestOptions<undefined>
  ): Observable<HttpEvent<any>>;
  public deleteCommentRecords(requestParameters?: DeleteCommentRecordsParams, ...args: RequestArgs): Observable<any> {
    const commentId = requestParameters?.commentId;
    const seasonId = requestParameters?.seasonId;
    const recordId = requestParameters?.recordId;
    this.checkRequired('deleteCommentRecords', { commentId, seasonId, recordId });
    return this.sendRequest(args, {
      method: 'delete',
      path: `/partner/api/v1/seasons/incentive/${this.configuration.encodeParam({ name: 'seasonId', value: seasonId, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: undefined })}/records/${this.configuration.encodeParam({ name: 'recordId', value: recordId, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: undefined })}/comments/${this.configuration.encodeParam({ name: 'commentId', value: commentId, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: 'uuid' })}`,
      accepts: []
    });
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public exportMonitoring(
    requestParameters?: ExportMonitoringParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<TransactionStatusOfExportStatusMetadata>;
  public exportMonitoring(
    requestParameters?: ExportMonitoringParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpResponse<TransactionStatusOfExportStatusMetadata>>;
  public exportMonitoring(
    requestParameters?: ExportMonitoringParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpEvent<TransactionStatusOfExportStatusMetadata>>;
  public exportMonitoring(requestParameters?: ExportMonitoringParams, ...args: RequestArgs): Observable<any> {
    const seasonId = requestParameters?.seasonId;
    this.checkRequired('exportMonitoring', { seasonId });
    return this.sendRequest(args, {
      method: 'put',
      path: `/seasons/incentive/${this.configuration.encodeParam({ name: 'seasonId', value: seasonId, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: 'uuid' })}/partner/v1/monitoring/export`,
      accepts: ['text/plain', 'application/json', 'text/json'],
      query: {
        Id: requestParameters?.id,
        Gid: requestParameters?.gid,
        FirstName: requestParameters?.firstName,
        LastName: requestParameters?.lastName,
        Country: requestParameters?.country,
        Are: requestParameters?.are,
        OrgCode: requestParameters?.orgCode,
        PlanName: requestParameters?.planName,
        State: requestParameters?.state,
        StartDate: requestParameters?.startDate,
        EndDate: requestParameters?.endDate,
        PayoutDate: requestParameters?.payoutDate,
        AssignmentManager: requestParameters?.assignmentManager,
        AssignmentId: requestParameters?.assignmentId,
        LetterType: requestParameters?.letterType,
        ProcessStates: requestParameters?.processStates,
        RecordCommunicationStates: requestParameters?.recordCommunicationStates,
        Workflow: requestParameters?.workflow,
        Template: requestParameters?.template,
        IsDesignReady: requestParameters?.isDesignReady,
        PayoutState: requestParameters?.payoutState,
        ManagerSetMercerJobCode: requestParameters?.managerSetMercerJobCode,
        EditedMercerJobCode: requestParameters?.editedMercerJobCode,
        CurrentMercerJobCode: requestParameters?.currentMercerJobCode,
        IsMercerJobCodeValid: requestParameters?.isMercerJobCodeValid,
        IsGripCodeValid: requestParameters?.isGripCodeValid,
        LineManagerName: requestParameters?.lineManagerName,
        LineManagerGid: requestParameters?.lineManagerGid,
        SeasonId: requestParameters?.seasonId2,
        WorkflowInstanceState: requestParameters?.workflowInstanceState,
        Multiplier: requestParameters?.multiplier,
        OverallTargetAchievement: requestParameters?.overallTargetAchievement,
        PayoutAmount: requestParameters?.payoutAmount,
        PayoutCurrency: requestParameters?.payoutCurrency,
        IppAchievementValue: requestParameters?.ippAchievementValue,
        IncentivePaymentType: requestParameters?.incentivePaymentType,
        ContractStatus: requestParameters?.contractStatus
      }
    });
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public exportReassignments(
    requestParameters?: ExportReassignmentsParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<TransactionStatusOfExportStatusMetadata>;
  public exportReassignments(
    requestParameters?: ExportReassignmentsParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpResponse<TransactionStatusOfExportStatusMetadata>>;
  public exportReassignments(
    requestParameters?: ExportReassignmentsParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpEvent<TransactionStatusOfExportStatusMetadata>>;
  public exportReassignments(requestParameters?: ExportReassignmentsParams, ...args: RequestArgs): Observable<any> {
    const seasonId = requestParameters?.seasonId;
    this.checkRequired('exportReassignments', { seasonId });
    return this.sendRequest(args, {
      method: 'put',
      path: `/seasons/incentive/${this.configuration.encodeParam({ name: 'seasonId', value: seasonId, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: 'uuid' })}/partner/v1/reassignments/export`,
      accepts: ['text/plain', 'application/json', 'text/json'],
      query: {
        Search: requestParameters?.search,
        TargetProperty: requestParameters?.targetProperty,
        Id: requestParameters?.id,
        SeasonId: requestParameters?.seasonId2,
        Gid: requestParameters?.gid,
        Firstname: requestParameters?.firstname,
        Lastname: requestParameters?.lastname,
        Reason: requestParameters?.reason,
        StartDate: requestParameters?.startDate,
        EndDate: requestParameters?.endDate,
        Action: requestParameters?.action,
        State: requestParameters?.state,
        AreNew: requestParameters?.areNew,
        AreCurrent: requestParameters?.areCurrent,
        CountryNew: requestParameters?.countryNew,
        CountryCurrent: requestParameters?.countryCurrent,
        OrgCodeNew: requestParameters?.orgCodeNew,
        OrgCodeCurrent: requestParameters?.orgCodeCurrent,
        PlanNameNew: requestParameters?.planNameNew,
        PlanNameCurrent: requestParameters?.planNameCurrent,
        TargetIncentiveAmountCurrent: requestParameters?.targetIncentiveAmountCurrent,
        TargetIncentiveAmountNew: requestParameters?.targetIncentiveAmountNew,
        IncentivePaymentTypeCurrent: requestParameters?.incentivePaymentTypeCurrent,
        IncentivePaymentTypeNew: requestParameters?.incentivePaymentTypeNew,
        OrgClusterCurrent: requestParameters?.orgClusterCurrent,
        OrgClusterNew: requestParameters?.orgClusterNew,
        ManagementType: requestParameters?.managementType,
        NewManagementType: requestParameters?.newManagementType
      }
    });
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public getEmployeeByReassignmentIdReassignments(
    requestParameters?: GetEmployeeByReassignmentIdReassignmentsParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<IncentiveEmployeesEmployee>;
  public getEmployeeByReassignmentIdReassignments(
    requestParameters?: GetEmployeeByReassignmentIdReassignmentsParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpResponse<IncentiveEmployeesEmployee>>;
  public getEmployeeByReassignmentIdReassignments(
    requestParameters?: GetEmployeeByReassignmentIdReassignmentsParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpEvent<IncentiveEmployeesEmployee>>;
  public getEmployeeByReassignmentIdReassignments(
    requestParameters?: GetEmployeeByReassignmentIdReassignmentsParams,
    ...args: RequestArgs
  ): Observable<any> {
    const seasonId = requestParameters?.seasonId;
    const id = requestParameters?.id;
    this.checkRequired('getEmployeeByReassignmentIdReassignments', { seasonId, id });
    return this.sendRequest(args, {
      method: 'get',
      path: `/seasons/incentive/${this.configuration.encodeParam({ name: 'seasonId', value: seasonId, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: 'uuid' })}/partner/v1/reassignments/${this.configuration.encodeParam({ name: 'id', value: id, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: 'uuid' })}/employee`,
      accepts: ['text/plain', 'application/json', 'text/json']
    });
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public getEmployeeForManualReassignmentReassignments(
    requestParameters?: GetEmployeeForManualReassignmentReassignmentsParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<PageOfIncentiveEmployeesEmployee>;
  public getEmployeeForManualReassignmentReassignments(
    requestParameters?: GetEmployeeForManualReassignmentReassignmentsParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpResponse<PageOfIncentiveEmployeesEmployee>>;
  public getEmployeeForManualReassignmentReassignments(
    requestParameters?: GetEmployeeForManualReassignmentReassignmentsParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpEvent<PageOfIncentiveEmployeesEmployee>>;
  public getEmployeeForManualReassignmentReassignments(
    requestParameters?: GetEmployeeForManualReassignmentReassignmentsParams,
    ...args: RequestArgs
  ): Observable<any> {
    const seasonId = requestParameters?.seasonId;
    const search = requestParameters?.search;
    this.checkRequired('getEmployeeForManualReassignmentReassignments', { seasonId, search });
    return this.sendRequest(args, {
      method: 'get',
      path: `/seasons/incentive/${this.configuration.encodeParam({ name: 'seasonId', value: seasonId, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: 'uuid' })}/partner/v1/reassignments/employees`,
      accepts: ['text/plain', 'application/json', 'text/json'],
      query: {
        Search: search,
        Page: requestParameters?.page,
        Size: requestParameters?.size,
        OrderBy: requestParameters?.orderBy,
        Property: requestParameters?.property
      }
    });
  }

  /**
   * Mass accepts reassignments as HR BP either via query or by providing a list of ids
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public incentivePartnerAcceptManyReassignmentAcknowledgements(
    requestParameters?: IncentivePartnerAcceptManyReassignmentAcknowledgementsParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<TransactionStatusOfReassignmentsBatchMetadata>;
  public incentivePartnerAcceptManyReassignmentAcknowledgements(
    requestParameters?: IncentivePartnerAcceptManyReassignmentAcknowledgementsParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpResponse<TransactionStatusOfReassignmentsBatchMetadata>>;
  public incentivePartnerAcceptManyReassignmentAcknowledgements(
    requestParameters?: IncentivePartnerAcceptManyReassignmentAcknowledgementsParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpEvent<TransactionStatusOfReassignmentsBatchMetadata>>;
  public incentivePartnerAcceptManyReassignmentAcknowledgements(
    requestParameters?: IncentivePartnerAcceptManyReassignmentAcknowledgementsParams,
    ...args: RequestArgs
  ): Observable<any> {
    const seasonId = requestParameters?.seasonId;
    this.checkRequired('incentivePartnerAcceptManyReassignmentAcknowledgements', { seasonId });
    return this.sendRequest(args, {
      method: 'put',
      path: `/seasons/incentive/${this.configuration.encodeParam({ name: 'seasonId', value: seasonId, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: 'uuid' })}/partner/v1/reassignments/accept`,
      accepts: ['text/plain', 'application/json', 'text/json'],
      query: {
        Search: requestParameters?.search,
        TargetProperty: requestParameters?.targetProperty,
        Id: requestParameters?.id,
        SeasonId: requestParameters?.seasonId2,
        Gid: requestParameters?.gid,
        Firstname: requestParameters?.firstname,
        Lastname: requestParameters?.lastname,
        Reason: requestParameters?.reason,
        StartDate: requestParameters?.startDate,
        EndDate: requestParameters?.endDate,
        Action: requestParameters?.action,
        State: requestParameters?.state,
        AreNew: requestParameters?.areNew,
        AreCurrent: requestParameters?.areCurrent,
        CountryNew: requestParameters?.countryNew,
        CountryCurrent: requestParameters?.countryCurrent,
        OrgCodeNew: requestParameters?.orgCodeNew,
        OrgCodeCurrent: requestParameters?.orgCodeCurrent,
        PlanNameNew: requestParameters?.planNameNew,
        PlanNameCurrent: requestParameters?.planNameCurrent,
        TargetIncentiveAmountCurrent: requestParameters?.targetIncentiveAmountCurrent,
        TargetIncentiveAmountNew: requestParameters?.targetIncentiveAmountNew,
        IncentivePaymentTypeCurrent: requestParameters?.incentivePaymentTypeCurrent,
        IncentivePaymentTypeNew: requestParameters?.incentivePaymentTypeNew,
        OrgClusterCurrent: requestParameters?.orgClusterCurrent,
        OrgClusterNew: requestParameters?.orgClusterNew,
        ManagementType: requestParameters?.managementType,
        NewManagementType: requestParameters?.newManagementType
      },
      body: requestParameters?.acknowledgeManyReassignmentsPartner,
      consumes: ['application/json-patch+json', 'application/json', 'text/json', 'application/*+json']
    });
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public incentivePartnerAcceptReassignmentAcknowledgements(
    requestParameters?: IncentivePartnerAcceptReassignmentAcknowledgementsParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<Reassignment>;
  public incentivePartnerAcceptReassignmentAcknowledgements(
    requestParameters?: IncentivePartnerAcceptReassignmentAcknowledgementsParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpResponse<Reassignment>>;
  public incentivePartnerAcceptReassignmentAcknowledgements(
    requestParameters?: IncentivePartnerAcceptReassignmentAcknowledgementsParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpEvent<Reassignment>>;
  public incentivePartnerAcceptReassignmentAcknowledgements(
    requestParameters?: IncentivePartnerAcceptReassignmentAcknowledgementsParams,
    ...args: RequestArgs
  ): Observable<any> {
    const reassignmentId = requestParameters?.reassignmentId;
    const seasonId = requestParameters?.seasonId;
    this.checkRequired('incentivePartnerAcceptReassignmentAcknowledgements', { reassignmentId, seasonId });
    return this.sendRequest(args, {
      method: 'put',
      path: `/seasons/incentive/${this.configuration.encodeParam({ name: 'seasonId', value: seasonId, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: undefined })}/partner/v1/reassignments/${this.configuration.encodeParam({ name: 'reassignmentId', value: reassignmentId, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: 'uuid' })}/accept`,
      accepts: ['text/plain', 'application/json', 'text/json']
    });
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public incentivePartnerCalculateManyProrationsRecordCalculations(
    requestParameters?: IncentivePartnerCalculateManyProrationsRecordCalculationsParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<TransactionStatusOfIncentiveProrationCalculationMetadata>;
  public incentivePartnerCalculateManyProrationsRecordCalculations(
    requestParameters?: IncentivePartnerCalculateManyProrationsRecordCalculationsParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpResponse<TransactionStatusOfIncentiveProrationCalculationMetadata>>;
  public incentivePartnerCalculateManyProrationsRecordCalculations(
    requestParameters?: IncentivePartnerCalculateManyProrationsRecordCalculationsParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpEvent<TransactionStatusOfIncentiveProrationCalculationMetadata>>;
  public incentivePartnerCalculateManyProrationsRecordCalculations(
    requestParameters?: IncentivePartnerCalculateManyProrationsRecordCalculationsParams,
    ...args: RequestArgs
  ): Observable<any> {
    const seasonId = requestParameters?.seasonId;
    this.checkRequired('incentivePartnerCalculateManyProrationsRecordCalculations', { seasonId });
    return this.sendRequest(args, {
      method: 'put',
      path: `/partner/api/v1/seasons/incentive/${this.configuration.encodeParam({ name: 'seasonId', value: seasonId, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: 'uuid' })}/records/proration`,
      accepts: ['text/plain', 'application/json', 'text/json'],
      query: {
        Id: requestParameters?.id,
        Gid: requestParameters?.gid,
        FirstName: requestParameters?.firstName,
        LastName: requestParameters?.lastName,
        Country: requestParameters?.country,
        Are: requestParameters?.are,
        OrgCode: requestParameters?.orgCode,
        PlanName: requestParameters?.planName,
        State: requestParameters?.state,
        StartDate: requestParameters?.startDate,
        EndDate: requestParameters?.endDate,
        PayoutDate: requestParameters?.payoutDate,
        AssignmentManager: requestParameters?.assignmentManager,
        AssignmentId: requestParameters?.assignmentId,
        LetterType: requestParameters?.letterType,
        ProcessStates: requestParameters?.processStates,
        RecordCommunicationStates: requestParameters?.recordCommunicationStates,
        Workflow: requestParameters?.workflow,
        Template: requestParameters?.template,
        IsDesignReady: requestParameters?.isDesignReady,
        PayoutState: requestParameters?.payoutState,
        LineManagerName: requestParameters?.lineManagerName,
        LineManagerGid: requestParameters?.lineManagerGid,
        SeasonId: requestParameters?.seasonId2,
        WorkflowInstanceState: requestParameters?.workflowInstanceState,
        Multiplier: requestParameters?.multiplier,
        OverallTargetAchievement: requestParameters?.overallTargetAchievement,
        PayoutAmount: requestParameters?.payoutAmount,
        PayoutCurrency: requestParameters?.payoutCurrency,
        IppAchievementValue: requestParameters?.ippAchievementValue,
        IncentivePaymentType: requestParameters?.incentivePaymentType,
        MeritTitle: requestParameters?.meritTitle,
        EquityTitle: requestParameters?.equityTitle,
        EquitySubTitle: requestParameters?.equitySubTitle,
        ManuallyChanged: requestParameters?.manuallyChanged,
        NewHire: requestParameters?.newHire,
        Promotion: requestParameters?.promotion,
        Termination: requestParameters?.termination,
        PopulationChange: requestParameters?.populationChange,
        LineManagerFirstName: requestParameters?.lineManagerFirstName,
        LineManagerLastName: requestParameters?.lineManagerLastName,
        CompanyManagerFirstName: requestParameters?.companyManagerFirstName,
        CompanyManagerGid: requestParameters?.companyManagerGid,
        CompanyManagerLastName: requestParameters?.companyManagerLastName,
        TemplateName: requestParameters?.templateName,
        WorkflowType: requestParameters?.workflowType,
        AutoApprove: requestParameters?.autoApprove,
        ApprovalRequired: requestParameters?.approvalRequired,
        LetterState: requestParameters?.letterState,
        ProcessState: requestParameters?.processState,
        ExportState: requestParameters?.exportState,
        PayrollState: requestParameters?.payrollState,
        MeritRelevancy: requestParameters?.meritRelevancy,
        ApprovedByCompanyManager: requestParameters?.approvedByCompanyManager,
        AllocationWorkflowType: requestParameters?.allocationWorkflowType,
        ReadyToPayroll: requestParameters?.readyToPayroll,
        EquityRelevancy: requestParameters?.equityRelevancy,
        HasOtpIncrease: requestParameters?.hasOtpIncrease,
        IsOtpOnly: requestParameters?.isOtpOnly,
        PlanTitle: requestParameters?.planTitle,
        LocalCurrency: requestParameters?.localCurrency,
        ProposalAmount: requestParameters?.proposalAmount,
        ProposalDate: requestParameters?.proposalDate,
        SpecialPaymentReason: requestParameters?.specialPaymentReason,
        ProposalState: requestParameters?.proposalState,
        TemplateLetterName: requestParameters?.templateLetterName,
        MeasurementDate: requestParameters?.measurementDate
      },
      body: requestParameters?.calculateManyProrations,
      consumes: ['application/json-patch+json', 'application/json', 'text/json', 'application/*+json']
    });
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public incentivePartnerCalculateProrationRecordCalculations(
    requestParameters?: IncentivePartnerCalculateProrationRecordCalculationsParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<TransactionStatusOfIncentiveProrationCalculationMetadata>;
  public incentivePartnerCalculateProrationRecordCalculations(
    requestParameters?: IncentivePartnerCalculateProrationRecordCalculationsParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpResponse<TransactionStatusOfIncentiveProrationCalculationMetadata>>;
  public incentivePartnerCalculateProrationRecordCalculations(
    requestParameters?: IncentivePartnerCalculateProrationRecordCalculationsParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpEvent<TransactionStatusOfIncentiveProrationCalculationMetadata>>;
  public incentivePartnerCalculateProrationRecordCalculations(
    requestParameters?: IncentivePartnerCalculateProrationRecordCalculationsParams,
    ...args: RequestArgs
  ): Observable<any> {
    const seasonId = requestParameters?.seasonId;
    const recordId = requestParameters?.recordId;
    this.checkRequired('incentivePartnerCalculateProrationRecordCalculations', { seasonId, recordId });
    return this.sendRequest(args, {
      method: 'put',
      path: `/partner/api/v1/seasons/incentive/${this.configuration.encodeParam({ name: 'seasonId', value: seasonId, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: 'uuid' })}/records/${this.configuration.encodeParam({ name: 'recordId', value: recordId, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: 'uuid' })}/proration`,
      accepts: ['text/plain', 'application/json', 'text/json']
    });
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public incentivePartnerCreateManualReassignments(
    requestParameters?: IncentivePartnerCreateManualReassignmentsParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<Reassignment>;
  public incentivePartnerCreateManualReassignments(
    requestParameters?: IncentivePartnerCreateManualReassignmentsParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpResponse<Reassignment>>;
  public incentivePartnerCreateManualReassignments(
    requestParameters?: IncentivePartnerCreateManualReassignmentsParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpEvent<Reassignment>>;
  public incentivePartnerCreateManualReassignments(
    requestParameters?: IncentivePartnerCreateManualReassignmentsParams,
    ...args: RequestArgs
  ): Observable<any> {
    const seasonId = requestParameters?.seasonId;
    this.checkRequired('incentivePartnerCreateManualReassignments', { seasonId });
    return this.sendRequest(args, {
      method: 'post',
      path: `/seasons/incentive/${this.configuration.encodeParam({ name: 'seasonId', value: seasonId, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: 'uuid' })}/partner/v1/reassignments/manuals`,
      accepts: ['text/plain', 'application/json', 'text/json'],
      body: requestParameters?.createManualReassignment,
      consumes: ['application/json-patch+json', 'application/json', 'text/json', 'application/*+json']
    });
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public incentivePartnerGetReassignments(
    requestParameters?: IncentivePartnerGetReassignmentsParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<Reassignment>;
  public incentivePartnerGetReassignments(
    requestParameters?: IncentivePartnerGetReassignmentsParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpResponse<Reassignment>>;
  public incentivePartnerGetReassignments(
    requestParameters?: IncentivePartnerGetReassignmentsParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpEvent<Reassignment>>;
  public incentivePartnerGetReassignments(
    requestParameters?: IncentivePartnerGetReassignmentsParams,
    ...args: RequestArgs
  ): Observable<any> {
    const seasonId = requestParameters?.seasonId;
    const id = requestParameters?.id;
    this.checkRequired('incentivePartnerGetReassignments', { seasonId, id });
    return this.sendRequest(args, {
      method: 'get',
      path: `/seasons/incentive/${this.configuration.encodeParam({ name: 'seasonId', value: seasonId, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: 'uuid' })}/partner/v1/reassignments/${this.configuration.encodeParam({ name: 'id', value: id, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: 'uuid' })}`,
      accepts: ['text/plain', 'application/json', 'text/json']
    });
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public incentivePartnerGetRecords(
    requestParameters?: IncentivePartnerGetRecordsParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<AssignmentRecordPartner>;
  public incentivePartnerGetRecords(
    requestParameters?: IncentivePartnerGetRecordsParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpResponse<AssignmentRecordPartner>>;
  public incentivePartnerGetRecords(
    requestParameters?: IncentivePartnerGetRecordsParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpEvent<AssignmentRecordPartner>>;
  public incentivePartnerGetRecords(
    requestParameters?: IncentivePartnerGetRecordsParams,
    ...args: RequestArgs
  ): Observable<any> {
    const id = requestParameters?.id;
    const seasonId = requestParameters?.seasonId;
    this.checkRequired('incentivePartnerGetRecords', { id, seasonId });
    return this.sendRequest(args, {
      method: 'get',
      path: `/partner/api/v1/seasons/incentive/${this.configuration.encodeParam({ name: 'seasonId', value: seasonId, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: undefined })}/records/${this.configuration.encodeParam({ name: 'id', value: id, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: 'uuid' })}`,
      accepts: ['text/plain', 'application/json', 'text/json']
    });
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public incentivePartnerGetSeasons(
    requestParameters?: IncentivePartnerGetSeasonsParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<SeasonModel>;
  public incentivePartnerGetSeasons(
    requestParameters?: IncentivePartnerGetSeasonsParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpResponse<SeasonModel>>;
  public incentivePartnerGetSeasons(
    requestParameters?: IncentivePartnerGetSeasonsParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpEvent<SeasonModel>>;
  public incentivePartnerGetSeasons(
    requestParameters?: IncentivePartnerGetSeasonsParams,
    ...args: RequestArgs
  ): Observable<any> {
    const id = requestParameters?.id;
    this.checkRequired('incentivePartnerGetSeasons', { id });
    return this.sendRequest(args, {
      method: 'get',
      path: `/seasons/incentive/partner/v1/${this.configuration.encodeParam({ name: 'id', value: id, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: 'uuid' })}`,
      accepts: ['text/plain', 'application/json', 'text/json']
    });
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public incentivePartnerQueryFieldValuesReassignments(
    requestParameters?: IncentivePartnerQueryFieldValuesReassignmentsParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<PageOfString>;
  public incentivePartnerQueryFieldValuesReassignments(
    requestParameters?: IncentivePartnerQueryFieldValuesReassignmentsParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpResponse<PageOfString>>;
  public incentivePartnerQueryFieldValuesReassignments(
    requestParameters?: IncentivePartnerQueryFieldValuesReassignmentsParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpEvent<PageOfString>>;
  public incentivePartnerQueryFieldValuesReassignments(
    requestParameters?: IncentivePartnerQueryFieldValuesReassignmentsParams,
    ...args: RequestArgs
  ): Observable<any> {
    const seasonId = requestParameters?.seasonId;
    this.checkRequired('incentivePartnerQueryFieldValuesReassignments', { seasonId });
    return this.sendRequest(args, {
      method: 'get',
      path: `/seasons/incentive/${this.configuration.encodeParam({ name: 'seasonId', value: seasonId, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: 'uuid' })}/partner/v1/reassignments/field-values`,
      accepts: ['text/plain', 'application/json', 'text/json'],
      query: {
        TargetProperty: requestParameters?.targetProperty,
        Plan: requestParameters?.plan,
        Country: requestParameters?.country,
        Are: requestParameters?.are,
        OrgCluster: requestParameters?.orgCluster,
        ManagementType: requestParameters?.managementType,
        IPT: requestParameters?.iPT,
        NewPlan: requestParameters?.newPlan,
        NewCountry: requestParameters?.newCountry,
        NewAre: requestParameters?.newAre,
        NewOrgCluster: requestParameters?.newOrgCluster,
        NewManagementType: requestParameters?.newManagementType,
        NewIPT: requestParameters?.newIPT,
        Reason: requestParameters?.reason,
        State: requestParameters?.state,
        OrgCodeNew: requestParameters?.orgCodeNew,
        OrgCodeCurrent: requestParameters?.orgCodeCurrent,
        Page: requestParameters?.page,
        Size: requestParameters?.size
      }
    });
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public incentivePartnerQueryFieldValuesRecords(
    requestParameters?: IncentivePartnerQueryFieldValuesRecordsParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<PageOfString>;
  public incentivePartnerQueryFieldValuesRecords(
    requestParameters?: IncentivePartnerQueryFieldValuesRecordsParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpResponse<PageOfString>>;
  public incentivePartnerQueryFieldValuesRecords(
    requestParameters?: IncentivePartnerQueryFieldValuesRecordsParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpEvent<PageOfString>>;
  public incentivePartnerQueryFieldValuesRecords(
    requestParameters?: IncentivePartnerQueryFieldValuesRecordsParams,
    ...args: RequestArgs
  ): Observable<any> {
    const seasonId = requestParameters?.seasonId;
    this.checkRequired('incentivePartnerQueryFieldValuesRecords', { seasonId });
    return this.sendRequest(args, {
      method: 'get',
      path: `/partner/api/v1/seasons/incentive/${this.configuration.encodeParam({ name: 'seasonId', value: seasonId, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: 'uuid' })}/records/field-values`,
      accepts: ['text/plain', 'application/json', 'text/json'],
      query: {
        TargetProperty: requestParameters?.targetProperty,
        AssignmentId: requestParameters?.assignmentId,
        Gid: requestParameters?.gid,
        Firstname: requestParameters?.firstname,
        Lastname: requestParameters?.lastname,
        Are: requestParameters?.are,
        Country: requestParameters?.country,
        OrgCode: requestParameters?.orgCode,
        PlanName: requestParameters?.planName,
        LetterState: requestParameters?.letterState,
        RecordCommunicationStates: requestParameters?.recordCommunicationStates,
        ProcessStates: requestParameters?.processStates,
        Template: requestParameters?.template,
        Workflow: requestParameters?.workflow,
        PayoutState: requestParameters?.payoutState,
        ExportState: requestParameters?.exportState,
        IncentivePaymentType: requestParameters?.incentivePaymentType,
        ContractStatus: requestParameters?.contractStatus,
        Page: requestParameters?.page,
        Size: requestParameters?.size
      }
    });
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public incentivePartnerQueryPlans(
    requestParameters?: IncentivePartnerQueryPlansParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<PageOfPlan>;
  public incentivePartnerQueryPlans(
    requestParameters?: IncentivePartnerQueryPlansParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpResponse<PageOfPlan>>;
  public incentivePartnerQueryPlans(
    requestParameters?: IncentivePartnerQueryPlansParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpEvent<PageOfPlan>>;
  public incentivePartnerQueryPlans(
    requestParameters?: IncentivePartnerQueryPlansParams,
    ...args: RequestArgs
  ): Observable<any> {
    const seasonId = requestParameters?.seasonId;
    this.checkRequired('incentivePartnerQueryPlans', { seasonId });
    return this.sendRequest(args, {
      method: 'get',
      path: `/seasons/incentive/${this.configuration.encodeParam({ name: 'seasonId', value: seasonId, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: 'uuid' })}/partner/v1/plans`,
      accepts: ['text/plain', 'application/json', 'text/json'],
      query: {
        Page: requestParameters?.page,
        Size: requestParameters?.size,
        OrderBy: requestParameters?.orderBy,
        Property: requestParameters?.property,
        Title: requestParameters?.title,
        DisplayName: requestParameters?.displayName
      }
    });
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public incentivePartnerQueryReassignments(
    requestParameters?: IncentivePartnerQueryReassignmentsParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<PageOfReassignment>;
  public incentivePartnerQueryReassignments(
    requestParameters?: IncentivePartnerQueryReassignmentsParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpResponse<PageOfReassignment>>;
  public incentivePartnerQueryReassignments(
    requestParameters?: IncentivePartnerQueryReassignmentsParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpEvent<PageOfReassignment>>;
  public incentivePartnerQueryReassignments(
    requestParameters?: IncentivePartnerQueryReassignmentsParams,
    ...args: RequestArgs
  ): Observable<any> {
    const seasonId = requestParameters?.seasonId;
    this.checkRequired('incentivePartnerQueryReassignments', { seasonId });
    return this.sendRequest(args, {
      method: 'get',
      path: `/seasons/incentive/${this.configuration.encodeParam({ name: 'seasonId', value: seasonId, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: 'uuid' })}/partner/v1/reassignments`,
      accepts: ['text/plain', 'application/json', 'text/json'],
      query: {
        'Query.Search': requestParameters?.querySearch,
        'Query.TargetProperty': requestParameters?.queryTargetProperty,
        'Query.Id': requestParameters?.queryId,
        'Query.SeasonId': requestParameters?.querySeasonId,
        'Query.Gid': requestParameters?.queryGid,
        'Query.Firstname': requestParameters?.queryFirstname,
        'Query.Lastname': requestParameters?.queryLastname,
        'Query.Reason': requestParameters?.queryReason,
        'Query.StartDate': requestParameters?.queryStartDate,
        'Query.EndDate': requestParameters?.queryEndDate,
        'Query.Action': requestParameters?.queryAction,
        'Query.State': requestParameters?.queryState,
        'Query.AreNew': requestParameters?.queryAreNew,
        'Query.AreCurrent': requestParameters?.queryAreCurrent,
        'Query.CountryNew': requestParameters?.queryCountryNew,
        'Query.CountryCurrent': requestParameters?.queryCountryCurrent,
        'Query.OrgCodeNew': requestParameters?.queryOrgCodeNew,
        'Query.OrgCodeCurrent': requestParameters?.queryOrgCodeCurrent,
        'Query.PlanNameNew': requestParameters?.queryPlanNameNew,
        'Query.PlanNameCurrent': requestParameters?.queryPlanNameCurrent,
        'Query.TargetIncentiveAmountCurrent': requestParameters?.queryTargetIncentiveAmountCurrent,
        'Query.TargetIncentiveAmountNew': requestParameters?.queryTargetIncentiveAmountNew,
        'Query.IncentivePaymentTypeCurrent': requestParameters?.queryIncentivePaymentTypeCurrent,
        'Query.IncentivePaymentTypeNew': requestParameters?.queryIncentivePaymentTypeNew,
        'Query.OrgClusterCurrent': requestParameters?.queryOrgClusterCurrent,
        'Query.OrgClusterNew': requestParameters?.queryOrgClusterNew,
        'Query.ManagementType': requestParameters?.queryManagementType,
        'Query.NewManagementType': requestParameters?.queryNewManagementType,
        'Paging.Page': requestParameters?.pagingPage,
        'Paging.Size': requestParameters?.pagingSize,
        'Sorting.OrderBy': requestParameters?.sortingOrderBy,
        'Sorting.Property': requestParameters?.sortingProperty
      }
    });
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public incentivePartnerQueryRecords(
    requestParameters?: IncentivePartnerQueryRecordsParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<PageOfAssignmentRecordPartner>;
  public incentivePartnerQueryRecords(
    requestParameters?: IncentivePartnerQueryRecordsParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpResponse<PageOfAssignmentRecordPartner>>;
  public incentivePartnerQueryRecords(
    requestParameters?: IncentivePartnerQueryRecordsParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpEvent<PageOfAssignmentRecordPartner>>;
  public incentivePartnerQueryRecords(
    requestParameters?: IncentivePartnerQueryRecordsParams,
    ...args: RequestArgs
  ): Observable<any> {
    const seasonId = requestParameters?.seasonId;
    this.checkRequired('incentivePartnerQueryRecords', { seasonId });
    return this.sendRequest(args, {
      method: 'get',
      path: `/partner/api/v1/seasons/incentive/${this.configuration.encodeParam({ name: 'seasonId', value: seasonId, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: 'uuid' })}/records`,
      accepts: ['text/plain', 'application/json', 'text/json'],
      query: {
        employeeId: requestParameters?.employeeId,
        recordState: requestParameters?.recordState,
        'Query.Id': requestParameters?.queryId,
        'Query.Gid': requestParameters?.queryGid,
        'Query.FirstName': requestParameters?.queryFirstName,
        'Query.LastName': requestParameters?.queryLastName,
        'Query.Country': requestParameters?.queryCountry,
        'Query.Are': requestParameters?.queryAre,
        'Query.OrgCode': requestParameters?.queryOrgCode,
        'Query.PlanName': requestParameters?.queryPlanName,
        'Query.State': requestParameters?.queryState,
        'Query.StartDate': requestParameters?.queryStartDate,
        'Query.EndDate': requestParameters?.queryEndDate,
        'Query.PayoutDate': requestParameters?.queryPayoutDate,
        'Query.AssignmentManager': requestParameters?.queryAssignmentManager,
        'Query.AssignmentId': requestParameters?.queryAssignmentId,
        'Query.LetterType': requestParameters?.queryLetterType,
        'Query.ProcessStates': requestParameters?.queryProcessStates,
        'Query.RecordCommunicationStates': requestParameters?.queryRecordCommunicationStates,
        'Query.Workflow': requestParameters?.queryWorkflow,
        'Query.Template': requestParameters?.queryTemplate,
        'Query.IsDesignReady': requestParameters?.queryIsDesignReady,
        'Query.PayoutState': requestParameters?.queryPayoutState,
        'Query.LineManagerName': requestParameters?.queryLineManagerName,
        'Query.LineManagerGid': requestParameters?.queryLineManagerGid,
        'Query.SeasonId': requestParameters?.querySeasonId,
        'Query.WorkflowInstanceState': requestParameters?.queryWorkflowInstanceState,
        'Query.Multiplier': requestParameters?.queryMultiplier,
        'Query.OverallTargetAchievement': requestParameters?.queryOverallTargetAchievement,
        'Query.PayoutAmount': requestParameters?.queryPayoutAmount,
        'Query.PayoutCurrency': requestParameters?.queryPayoutCurrency,
        'Query.IppAchievementValue': requestParameters?.queryIppAchievementValue,
        'Query.IncentivePaymentType': requestParameters?.queryIncentivePaymentType,
        'Query.MeritTitle': requestParameters?.queryMeritTitle,
        'Query.EquityTitle': requestParameters?.queryEquityTitle,
        'Query.EquitySubTitle': requestParameters?.queryEquitySubTitle,
        'Query.ManuallyChanged': requestParameters?.queryManuallyChanged,
        'Query.NewHire': requestParameters?.queryNewHire,
        'Query.Promotion': requestParameters?.queryPromotion,
        'Query.Termination': requestParameters?.queryTermination,
        'Query.PopulationChange': requestParameters?.queryPopulationChange,
        'Query.LineManagerFirstName': requestParameters?.queryLineManagerFirstName,
        'Query.LineManagerLastName': requestParameters?.queryLineManagerLastName,
        'Query.CompanyManagerFirstName': requestParameters?.queryCompanyManagerFirstName,
        'Query.CompanyManagerGid': requestParameters?.queryCompanyManagerGid,
        'Query.CompanyManagerLastName': requestParameters?.queryCompanyManagerLastName,
        'Query.TemplateName': requestParameters?.queryTemplateName,
        'Query.WorkflowType': requestParameters?.queryWorkflowType,
        'Query.AutoApprove': requestParameters?.queryAutoApprove,
        'Query.ApprovalRequired': requestParameters?.queryApprovalRequired,
        'Query.LetterState': requestParameters?.queryLetterState,
        'Query.ProcessState': requestParameters?.queryProcessState,
        'Query.ExportState': requestParameters?.queryExportState,
        'Query.PayrollState': requestParameters?.queryPayrollState,
        'Query.MeritRelevancy': requestParameters?.queryMeritRelevancy,
        'Query.ApprovedByCompanyManager': requestParameters?.queryApprovedByCompanyManager,
        'Query.AllocationWorkflowType': requestParameters?.queryAllocationWorkflowType,
        'Query.ReadyToPayroll': requestParameters?.queryReadyToPayroll,
        'Query.EquityRelevancy': requestParameters?.queryEquityRelevancy,
        'Query.HasOtpIncrease': requestParameters?.queryHasOtpIncrease,
        'Query.IsOtpOnly': requestParameters?.queryIsOtpOnly,
        'Query.PlanTitle': requestParameters?.queryPlanTitle,
        'Query.LocalCurrency': requestParameters?.queryLocalCurrency,
        'Query.ProposalAmount': requestParameters?.queryProposalAmount,
        'Query.ProposalDate': requestParameters?.queryProposalDate,
        'Query.SpecialPaymentReason': requestParameters?.querySpecialPaymentReason,
        'Query.ProposalState': requestParameters?.queryProposalState,
        'Query.TemplateLetterName': requestParameters?.queryTemplateLetterName,
        'Query.MeasurementDate': requestParameters?.queryMeasurementDate,
        'Paging.Page': requestParameters?.pagingPage,
        'Paging.Size': requestParameters?.pagingSize,
        'Sorting.OrderBy': requestParameters?.sortingOrderBy,
        'Sorting.Property': requestParameters?.sortingProperty
      }
    });
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public incentivePartnerQuerySeasons(
    requestParameters?: IncentivePartnerQuerySeasonsParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<PageOfSeason>;
  public incentivePartnerQuerySeasons(
    requestParameters?: IncentivePartnerQuerySeasonsParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpResponse<PageOfSeason>>;
  public incentivePartnerQuerySeasons(
    requestParameters?: IncentivePartnerQuerySeasonsParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpEvent<PageOfSeason>>;
  public incentivePartnerQuerySeasons(
    requestParameters?: IncentivePartnerQuerySeasonsParams,
    ...args: RequestArgs
  ): Observable<any> {
    return this.sendRequest(args, {
      method: 'get',
      path: `/seasons/incentive/partner/v1`,
      accepts: ['text/plain', 'application/json', 'text/json'],
      query: {
        Page: requestParameters?.page,
        Size: requestParameters?.size,
        OrderBy: requestParameters?.orderBy,
        Property: requestParameters?.property
      }
    });
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public incentivePartnerRejectManyReassignmentAcknowledgements(
    requestParameters?: IncentivePartnerRejectManyReassignmentAcknowledgementsParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<TransactionStatusOfReassignmentsBatchMetadata>;
  public incentivePartnerRejectManyReassignmentAcknowledgements(
    requestParameters?: IncentivePartnerRejectManyReassignmentAcknowledgementsParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpResponse<TransactionStatusOfReassignmentsBatchMetadata>>;
  public incentivePartnerRejectManyReassignmentAcknowledgements(
    requestParameters?: IncentivePartnerRejectManyReassignmentAcknowledgementsParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpEvent<TransactionStatusOfReassignmentsBatchMetadata>>;
  public incentivePartnerRejectManyReassignmentAcknowledgements(
    requestParameters?: IncentivePartnerRejectManyReassignmentAcknowledgementsParams,
    ...args: RequestArgs
  ): Observable<any> {
    const seasonId = requestParameters?.seasonId;
    this.checkRequired('incentivePartnerRejectManyReassignmentAcknowledgements', { seasonId });
    return this.sendRequest(args, {
      method: 'put',
      path: `/seasons/incentive/${this.configuration.encodeParam({ name: 'seasonId', value: seasonId, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: 'uuid' })}/partner/v1/reassignments/reject`,
      accepts: ['text/plain', 'application/json', 'text/json'],
      query: {
        Search: requestParameters?.search,
        TargetProperty: requestParameters?.targetProperty,
        Id: requestParameters?.id,
        SeasonId: requestParameters?.seasonId2,
        Gid: requestParameters?.gid,
        Firstname: requestParameters?.firstname,
        Lastname: requestParameters?.lastname,
        Reason: requestParameters?.reason,
        StartDate: requestParameters?.startDate,
        EndDate: requestParameters?.endDate,
        Action: requestParameters?.action,
        State: requestParameters?.state,
        AreNew: requestParameters?.areNew,
        AreCurrent: requestParameters?.areCurrent,
        CountryNew: requestParameters?.countryNew,
        CountryCurrent: requestParameters?.countryCurrent,
        OrgCodeNew: requestParameters?.orgCodeNew,
        OrgCodeCurrent: requestParameters?.orgCodeCurrent,
        PlanNameNew: requestParameters?.planNameNew,
        PlanNameCurrent: requestParameters?.planNameCurrent,
        TargetIncentiveAmountCurrent: requestParameters?.targetIncentiveAmountCurrent,
        TargetIncentiveAmountNew: requestParameters?.targetIncentiveAmountNew,
        IncentivePaymentTypeCurrent: requestParameters?.incentivePaymentTypeCurrent,
        IncentivePaymentTypeNew: requestParameters?.incentivePaymentTypeNew,
        OrgClusterCurrent: requestParameters?.orgClusterCurrent,
        OrgClusterNew: requestParameters?.orgClusterNew,
        ManagementType: requestParameters?.managementType,
        NewManagementType: requestParameters?.newManagementType
      },
      body: requestParameters?.acknowledgeManyReassignmentsPartner,
      consumes: ['application/json-patch+json', 'application/json', 'text/json', 'application/*+json']
    });
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public incentivePartnerRejectReassignmentAcknowledgements(
    requestParameters?: IncentivePartnerRejectReassignmentAcknowledgementsParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<Reassignment>;
  public incentivePartnerRejectReassignmentAcknowledgements(
    requestParameters?: IncentivePartnerRejectReassignmentAcknowledgementsParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpResponse<Reassignment>>;
  public incentivePartnerRejectReassignmentAcknowledgements(
    requestParameters?: IncentivePartnerRejectReassignmentAcknowledgementsParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpEvent<Reassignment>>;
  public incentivePartnerRejectReassignmentAcknowledgements(
    requestParameters?: IncentivePartnerRejectReassignmentAcknowledgementsParams,
    ...args: RequestArgs
  ): Observable<any> {
    const reassignmentId = requestParameters?.reassignmentId;
    const seasonId = requestParameters?.seasonId;
    this.checkRequired('incentivePartnerRejectReassignmentAcknowledgements', { reassignmentId, seasonId });
    return this.sendRequest(args, {
      method: 'put',
      path: `/seasons/incentive/${this.configuration.encodeParam({ name: 'seasonId', value: seasonId, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: undefined })}/partner/v1/reassignments/${this.configuration.encodeParam({ name: 'reassignmentId', value: reassignmentId, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: 'uuid' })}/reject`,
      accepts: ['text/plain', 'application/json', 'text/json']
    });
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public incentivePartnerUpdateEmployeeSnapshots(
    requestParameters?: IncentivePartnerUpdateEmployeeSnapshotsParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<EmployeesEmployeeSnapshot>;
  public incentivePartnerUpdateEmployeeSnapshots(
    requestParameters?: IncentivePartnerUpdateEmployeeSnapshotsParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpResponse<EmployeesEmployeeSnapshot>>;
  public incentivePartnerUpdateEmployeeSnapshots(
    requestParameters?: IncentivePartnerUpdateEmployeeSnapshotsParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpEvent<EmployeesEmployeeSnapshot>>;
  public incentivePartnerUpdateEmployeeSnapshots(
    requestParameters?: IncentivePartnerUpdateEmployeeSnapshotsParams,
    ...args: RequestArgs
  ): Observable<any> {
    const seasonId = requestParameters?.seasonId;
    const recordId = requestParameters?.recordId;
    const id = requestParameters?.id;
    this.checkRequired('incentivePartnerUpdateEmployeeSnapshots', { seasonId, recordId, id });
    return this.sendRequest(args, {
      method: 'patch',
      path: `/seasons/incentive/${this.configuration.encodeParam({ name: 'seasonId', value: seasonId, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: 'uuid' })}/partner/v1/records/${this.configuration.encodeParam({ name: 'recordId', value: recordId, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: 'uuid' })}/employee-snapshots/${this.configuration.encodeParam({ name: 'id', value: id, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: 'uuid' })}`,
      accepts: ['text/plain', 'application/json', 'text/json'],
      body: requestParameters?.updateEmployeeSnapshotPartner,
      consumes: ['application/json-patch+json', 'application/json', 'text/json', 'application/*+json']
    });
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public incentivePartnerUpdateReassignments(
    requestParameters?: IncentivePartnerUpdateReassignmentsParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<Reassignment>;
  public incentivePartnerUpdateReassignments(
    requestParameters?: IncentivePartnerUpdateReassignmentsParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpResponse<Reassignment>>;
  public incentivePartnerUpdateReassignments(
    requestParameters?: IncentivePartnerUpdateReassignmentsParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpEvent<Reassignment>>;
  public incentivePartnerUpdateReassignments(
    requestParameters?: IncentivePartnerUpdateReassignmentsParams,
    ...args: RequestArgs
  ): Observable<any> {
    const id = requestParameters?.id;
    const seasonId = requestParameters?.seasonId;
    this.checkRequired('incentivePartnerUpdateReassignments', { id, seasonId });
    return this.sendRequest(args, {
      method: 'put',
      path: `/seasons/incentive/${this.configuration.encodeParam({ name: 'seasonId', value: seasonId, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: undefined })}/partner/v1/reassignments/${this.configuration.encodeParam({ name: 'id', value: id, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: 'uuid' })}`,
      accepts: ['text/plain', 'application/json', 'text/json'],
      body: requestParameters?.updateReassignment,
      consumes: ['application/json-patch+json', 'application/json', 'text/json', 'application/*+json']
    });
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public incentivePartnerUpdateRecordIndividualMultiplierValueRecords(
    requestParameters?: IncentivePartnerUpdateRecordIndividualMultiplierValueRecordsParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<IncentiveRecordPartner>;
  public incentivePartnerUpdateRecordIndividualMultiplierValueRecords(
    requestParameters?: IncentivePartnerUpdateRecordIndividualMultiplierValueRecordsParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpResponse<IncentiveRecordPartner>>;
  public incentivePartnerUpdateRecordIndividualMultiplierValueRecords(
    requestParameters?: IncentivePartnerUpdateRecordIndividualMultiplierValueRecordsParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpEvent<IncentiveRecordPartner>>;
  public incentivePartnerUpdateRecordIndividualMultiplierValueRecords(
    requestParameters?: IncentivePartnerUpdateRecordIndividualMultiplierValueRecordsParams,
    ...args: RequestArgs
  ): Observable<any> {
    const seasonId = requestParameters?.seasonId;
    const id = requestParameters?.id;
    this.checkRequired('incentivePartnerUpdateRecordIndividualMultiplierValueRecords', { seasonId, id });
    return this.sendRequest(args, {
      method: 'patch',
      path: `/partner/api/v1/seasons/incentive/${this.configuration.encodeParam({ name: 'seasonId', value: seasonId, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: 'uuid' })}/records/${this.configuration.encodeParam({ name: 'id', value: id, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: 'uuid' })}/individual-multiplier-value`,
      accepts: ['text/plain', 'application/json', 'text/json'],
      body: requestParameters?.updateRecordIndividualMultiplierValuePartner,
      consumes: ['application/json-patch+json', 'application/json', 'text/json', 'application/*+json']
    });
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public incentivePartnerUpdateRecordStatesRecords(
    requestParameters?: IncentivePartnerUpdateRecordStatesRecordsParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<RecordBatchPartnerResponse>;
  public incentivePartnerUpdateRecordStatesRecords(
    requestParameters?: IncentivePartnerUpdateRecordStatesRecordsParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpResponse<RecordBatchPartnerResponse>>;
  public incentivePartnerUpdateRecordStatesRecords(
    requestParameters?: IncentivePartnerUpdateRecordStatesRecordsParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpEvent<RecordBatchPartnerResponse>>;
  public incentivePartnerUpdateRecordStatesRecords(
    requestParameters?: IncentivePartnerUpdateRecordStatesRecordsParams,
    ...args: RequestArgs
  ): Observable<any> {
    const seasonId = requestParameters?.seasonId;
    this.checkRequired('incentivePartnerUpdateRecordStatesRecords', { seasonId });
    return this.sendRequest(args, {
      method: 'patch',
      path: `/partner/api/v1/seasons/incentive/${this.configuration.encodeParam({ name: 'seasonId', value: seasonId, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: 'uuid' })}/records/states`,
      accepts: ['text/plain', 'application/json', 'text/json'],
      query: {
        Id: requestParameters?.id,
        Gid: requestParameters?.gid,
        FirstName: requestParameters?.firstName,
        LastName: requestParameters?.lastName,
        Country: requestParameters?.country,
        Are: requestParameters?.are,
        OrgCode: requestParameters?.orgCode,
        PlanName: requestParameters?.planName,
        State: requestParameters?.state,
        StartDate: requestParameters?.startDate,
        EndDate: requestParameters?.endDate,
        PayoutDate: requestParameters?.payoutDate,
        AssignmentManager: requestParameters?.assignmentManager,
        AssignmentId: requestParameters?.assignmentId,
        LetterType: requestParameters?.letterType,
        ProcessStates: requestParameters?.processStates,
        RecordCommunicationStates: requestParameters?.recordCommunicationStates,
        Workflow: requestParameters?.workflow,
        Template: requestParameters?.template,
        IsDesignReady: requestParameters?.isDesignReady,
        PayoutState: requestParameters?.payoutState,
        LineManagerName: requestParameters?.lineManagerName,
        LineManagerGid: requestParameters?.lineManagerGid,
        SeasonId: requestParameters?.seasonId2,
        WorkflowInstanceState: requestParameters?.workflowInstanceState,
        Multiplier: requestParameters?.multiplier,
        OverallTargetAchievement: requestParameters?.overallTargetAchievement,
        PayoutAmount: requestParameters?.payoutAmount,
        PayoutCurrency: requestParameters?.payoutCurrency,
        IppAchievementValue: requestParameters?.ippAchievementValue,
        IncentivePaymentType: requestParameters?.incentivePaymentType,
        MeritTitle: requestParameters?.meritTitle,
        EquityTitle: requestParameters?.equityTitle,
        EquitySubTitle: requestParameters?.equitySubTitle,
        ManuallyChanged: requestParameters?.manuallyChanged,
        NewHire: requestParameters?.newHire,
        Promotion: requestParameters?.promotion,
        Termination: requestParameters?.termination,
        PopulationChange: requestParameters?.populationChange,
        LineManagerFirstName: requestParameters?.lineManagerFirstName,
        LineManagerLastName: requestParameters?.lineManagerLastName,
        CompanyManagerFirstName: requestParameters?.companyManagerFirstName,
        CompanyManagerGid: requestParameters?.companyManagerGid,
        CompanyManagerLastName: requestParameters?.companyManagerLastName,
        TemplateName: requestParameters?.templateName,
        WorkflowType: requestParameters?.workflowType,
        AutoApprove: requestParameters?.autoApprove,
        ApprovalRequired: requestParameters?.approvalRequired,
        LetterState: requestParameters?.letterState,
        ProcessState: requestParameters?.processState,
        ExportState: requestParameters?.exportState,
        PayrollState: requestParameters?.payrollState,
        MeritRelevancy: requestParameters?.meritRelevancy,
        ApprovedByCompanyManager: requestParameters?.approvedByCompanyManager,
        AllocationWorkflowType: requestParameters?.allocationWorkflowType,
        ReadyToPayroll: requestParameters?.readyToPayroll,
        EquityRelevancy: requestParameters?.equityRelevancy,
        HasOtpIncrease: requestParameters?.hasOtpIncrease,
        IsOtpOnly: requestParameters?.isOtpOnly,
        PlanTitle: requestParameters?.planTitle,
        LocalCurrency: requestParameters?.localCurrency,
        ProposalAmount: requestParameters?.proposalAmount,
        ProposalDate: requestParameters?.proposalDate,
        SpecialPaymentReason: requestParameters?.specialPaymentReason,
        ProposalState: requestParameters?.proposalState,
        TemplateLetterName: requestParameters?.templateLetterName,
        MeasurementDate: requestParameters?.measurementDate
      },
      body: requestParameters?.updateManyRecordStatesPartner,
      consumes: ['application/json-patch+json', 'application/json', 'text/json', 'application/*+json']
    });
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public incentivePartnerUpdateRecords(
    requestParameters?: IncentivePartnerUpdateRecordsParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<IncentiveRecordPartner>;
  public incentivePartnerUpdateRecords(
    requestParameters?: IncentivePartnerUpdateRecordsParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpResponse<IncentiveRecordPartner>>;
  public incentivePartnerUpdateRecords(
    requestParameters?: IncentivePartnerUpdateRecordsParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpEvent<IncentiveRecordPartner>>;
  public incentivePartnerUpdateRecords(
    requestParameters?: IncentivePartnerUpdateRecordsParams,
    ...args: RequestArgs
  ): Observable<any> {
    const seasonId = requestParameters?.seasonId;
    const id = requestParameters?.id;
    this.checkRequired('incentivePartnerUpdateRecords', { seasonId, id });
    return this.sendRequest(args, {
      method: 'patch',
      path: `/partner/api/v1/seasons/incentive/${this.configuration.encodeParam({ name: 'seasonId', value: seasonId, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: 'uuid' })}/records/${this.configuration.encodeParam({ name: 'id', value: id, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: 'uuid' })}`,
      accepts: ['text/plain', 'application/json', 'text/json'],
      body: requestParameters?.updateRecordPartner,
      consumes: ['application/json-patch+json', 'application/json', 'text/json', 'application/*+json']
    });
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public queryCommentsRecords(
    requestParameters?: QueryCommentsRecordsParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<PageOfIncentiveComment>;
  public queryCommentsRecords(
    requestParameters?: QueryCommentsRecordsParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpResponse<PageOfIncentiveComment>>;
  public queryCommentsRecords(
    requestParameters?: QueryCommentsRecordsParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpEvent<PageOfIncentiveComment>>;
  public queryCommentsRecords(requestParameters?: QueryCommentsRecordsParams, ...args: RequestArgs): Observable<any> {
    const recordId = requestParameters?.recordId;
    const seasonId = requestParameters?.seasonId;
    this.checkRequired('queryCommentsRecords', { recordId, seasonId });
    return this.sendRequest(args, {
      method: 'get',
      path: `/partner/api/v1/seasons/incentive/${this.configuration.encodeParam({ name: 'seasonId', value: seasonId, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: undefined })}/records/${this.configuration.encodeParam({ name: 'recordId', value: recordId, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: 'uuid' })}/comments`,
      accepts: ['text/plain', 'application/json', 'text/json'],
      query: { Page: requestParameters?.page, Size: requestParameters?.size }
    });
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public queryDashboardMonitoring(
    requestParameters?: QueryDashboardMonitoringParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<IncentivePartnerDashboardValues>;
  public queryDashboardMonitoring(
    requestParameters?: QueryDashboardMonitoringParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpResponse<IncentivePartnerDashboardValues>>;
  public queryDashboardMonitoring(
    requestParameters?: QueryDashboardMonitoringParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpEvent<IncentivePartnerDashboardValues>>;
  public queryDashboardMonitoring(
    requestParameters?: QueryDashboardMonitoringParams,
    ...args: RequestArgs
  ): Observable<any> {
    const seasonId = requestParameters?.seasonId;
    this.checkRequired('queryDashboardMonitoring', { seasonId });
    return this.sendRequest(args, {
      method: 'get',
      path: `/seasons/incentive/${this.configuration.encodeParam({ name: 'seasonId', value: seasonId, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: 'uuid' })}/partner/v1/monitoring/dashboard`,
      accepts: ['text/plain', 'application/json', 'text/json']
    });
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public queryFieldValuesMonitoring(
    requestParameters?: QueryFieldValuesMonitoringParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<PageOfString>;
  public queryFieldValuesMonitoring(
    requestParameters?: QueryFieldValuesMonitoringParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpResponse<PageOfString>>;
  public queryFieldValuesMonitoring(
    requestParameters?: QueryFieldValuesMonitoringParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpEvent<PageOfString>>;
  public queryFieldValuesMonitoring(
    requestParameters?: QueryFieldValuesMonitoringParams,
    ...args: RequestArgs
  ): Observable<any> {
    const seasonId = requestParameters?.seasonId;
    this.checkRequired('queryFieldValuesMonitoring', { seasonId });
    return this.sendRequest(args, {
      method: 'get',
      path: `/seasons/incentive/${this.configuration.encodeParam({ name: 'seasonId', value: seasonId, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: 'uuid' })}/partner/v1/monitoring/field-values`,
      accepts: ['text/plain', 'application/json', 'text/json'],
      query: {
        TargetProperty: requestParameters?.targetProperty,
        AssignmentId: requestParameters?.assignmentId,
        Gid: requestParameters?.gid,
        Firstname: requestParameters?.firstname,
        Lastname: requestParameters?.lastname,
        Are: requestParameters?.are,
        Country: requestParameters?.country,
        OrgCode: requestParameters?.orgCode,
        PlanName: requestParameters?.planName,
        LetterState: requestParameters?.letterState,
        RecordCommunicationStates: requestParameters?.recordCommunicationStates,
        ProcessStates: requestParameters?.processStates,
        Template: requestParameters?.template,
        Workflow: requestParameters?.workflow,
        PayoutState: requestParameters?.payoutState,
        ExportState: requestParameters?.exportState,
        IncentivePaymentType: requestParameters?.incentivePaymentType,
        ContractStatus: requestParameters?.contractStatus,
        Page: requestParameters?.page,
        Size: requestParameters?.size
      }
    });
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public queryMonitoring(
    requestParameters?: QueryMonitoringParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<PageOfMonitoringRecord>;
  public queryMonitoring(
    requestParameters?: QueryMonitoringParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpResponse<PageOfMonitoringRecord>>;
  public queryMonitoring(
    requestParameters?: QueryMonitoringParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpEvent<PageOfMonitoringRecord>>;
  public queryMonitoring(requestParameters?: QueryMonitoringParams, ...args: RequestArgs): Observable<any> {
    const seasonId = requestParameters?.seasonId;
    this.checkRequired('queryMonitoring', { seasonId });
    return this.sendRequest(args, {
      method: 'get',
      path: `/seasons/incentive/${this.configuration.encodeParam({ name: 'seasonId', value: seasonId, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: 'uuid' })}/partner/v1/monitoring`,
      accepts: ['text/plain', 'application/json', 'text/json'],
      query: {
        employeeId: requestParameters?.employeeId,
        recordState: requestParameters?.recordState,
        'Query.Id': requestParameters?.queryId,
        'Query.Gid': requestParameters?.queryGid,
        'Query.FirstName': requestParameters?.queryFirstName,
        'Query.LastName': requestParameters?.queryLastName,
        'Query.Country': requestParameters?.queryCountry,
        'Query.Are': requestParameters?.queryAre,
        'Query.OrgCode': requestParameters?.queryOrgCode,
        'Query.PlanName': requestParameters?.queryPlanName,
        'Query.State': requestParameters?.queryState,
        'Query.StartDate': requestParameters?.queryStartDate,
        'Query.EndDate': requestParameters?.queryEndDate,
        'Query.PayoutDate': requestParameters?.queryPayoutDate,
        'Query.AssignmentManager': requestParameters?.queryAssignmentManager,
        'Query.AssignmentId': requestParameters?.queryAssignmentId,
        'Query.LetterType': requestParameters?.queryLetterType,
        'Query.ProcessStates': requestParameters?.queryProcessStates,
        'Query.RecordCommunicationStates': requestParameters?.queryRecordCommunicationStates,
        'Query.Workflow': requestParameters?.queryWorkflow,
        'Query.Template': requestParameters?.queryTemplate,
        'Query.IsDesignReady': requestParameters?.queryIsDesignReady,
        'Query.PayoutState': requestParameters?.queryPayoutState,
        'Query.ManagerSetMercerJobCode': requestParameters?.queryManagerSetMercerJobCode,
        'Query.EditedMercerJobCode': requestParameters?.queryEditedMercerJobCode,
        'Query.CurrentMercerJobCode': requestParameters?.queryCurrentMercerJobCode,
        'Query.IsMercerJobCodeValid': requestParameters?.queryIsMercerJobCodeValid,
        'Query.IsGripCodeValid': requestParameters?.queryIsGripCodeValid,
        'Query.LineManagerName': requestParameters?.queryLineManagerName,
        'Query.LineManagerGid': requestParameters?.queryLineManagerGid,
        'Query.SeasonId': requestParameters?.querySeasonId,
        'Query.WorkflowInstanceState': requestParameters?.queryWorkflowInstanceState,
        'Query.Multiplier': requestParameters?.queryMultiplier,
        'Query.OverallTargetAchievement': requestParameters?.queryOverallTargetAchievement,
        'Query.PayoutAmount': requestParameters?.queryPayoutAmount,
        'Query.PayoutCurrency': requestParameters?.queryPayoutCurrency,
        'Query.IppAchievementValue': requestParameters?.queryIppAchievementValue,
        'Query.IncentivePaymentType': requestParameters?.queryIncentivePaymentType,
        'Query.ContractStatus': requestParameters?.queryContractStatus,
        'Paging.Page': requestParameters?.pagingPage,
        'Paging.Size': requestParameters?.pagingSize,
        'Sorting.OrderBy': requestParameters?.sortingOrderBy,
        'Sorting.Property': requestParameters?.sortingProperty
      }
    });
  }
}
